export default {
  zh: {
      // 模型名称
      modelName: 'WeryAI Video 1.0',

      // 页面标题和描述
      pageTitle: 'WeryAI Video 1.0 AI视频生成器 - WeryAI旗舰级AI视频创作工具',
      pageDescription:
          'WeryAI Video 1.0 是 WeryAI 平台推出的首款旗舰级 AI 视频生成模型，具备多镜头叙事、智能图生视频、极速渲染、物理级动作模拟等核心功能。在WeryAI平台免费试用。',
      pageKeywords:
          'WeryAI Video 1.0, AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, WeryAI, 多镜头叙事, 图生视频',

      // 生成器部分
      generatorTitle: 'WeryAI Video 1.0 视频生成器',
      generatorDescription:
          'WeryAI Video 1.0 是 WeryAI 平台重磅推出的首款旗舰级 AI 视频生成模型。它代表了我们对"速度"与"艺术性"完美平衡的极致追求，内置先进的语义理解算法与物理模拟引擎，首创<span class="text-text-active">"原生多镜头叙事"</span>能力。<span class="text-text-active">在 WeryAI 视频生成器上免费试用</span>！',

      // 标签页
      tabImageToVideo: '图生视频',
      tabTextToVideo: '文生视频',

      // 核心功能部分
      coreFeaturesTitle: 'WeryAI Video 1.0 核心功能',
      coreFeaturesSubtitle: '探索 WeryAI Video 1.0 的核心功能，开启下一代视频创作之旅',

      // 多镜头叙事系统
      multiShotTitle: '多镜头叙事系统',
      multiShotDescription:
          'WeryAI Video 1.0 的核心突破。它打破了传统模型单镜头生成的限制，能够理解并执行复杂的运镜指令（如推拉摇移、转场）。模型能确保在镜头切换过程中，角色特征、场景光影保持高度统一，直接生成一段具有完整叙事逻辑的视频。',

      // 智能图生视频引擎
      imageToVideoTitle: '智能图生视频引擎',
      imageToVideoDescription:
          '赋予静态图像以生命。只需上传一张参考图，WeryAI Video 1.0 即可精准识别主体结构，赋予其符合物理规律的动态效果。无论是让静止的人物自然眨眼、微笑，还是让风景画中的流水流动，都能在保留原画质感的同时实现自然动画化。',

      // 极速渲染技术
      fastRenderTitle: '极速渲染技术',
      fastRenderDescription:
          '专为高频创作优化。得益于 WeryAI 独特的模型架构优化，Video 1.0 的生成速度远超行业平均水平。您可以在极短时间内（通常40-60秒）获得 5-10 秒的高清视频片段，让创意迭代不再等待。',

      // 物理级动作模拟
      physicsTitle: '物理级动作模拟',
      physicsDescription:
          '拒绝"AI幻觉"带来的崩坏感。我们的模型经过海量物理动态数据训练，对流体、布料、重力等物理规则有深刻理解。生成的视频中，人物动作流畅自然，物体碰撞符合真实世界逻辑。',

      // 如何使用部分
      howToUseTitle: '如何使用 WeryAI Video 1.0',
      howToUseSubtitle: '简单三步，开始创作',
      step1Title: '选择模型',
      step1Description:
          '在 AI 视频工具中选择 <span class="highlight-text">WeryAI Video 1.0</span> 模型',
      step2Title: '输入提示词',
      step2Description: '在文本框中描述您的创意故事，或上传图片开启"图生视频"模式。',
      step3Title: '生成视频',
      step3Description: '选择您的目标画幅（16:9 电影感或 9:16 竖屏）及视频时长，点击"生成"按钮，稍等片刻即可预览并下载您的视频大片。',

      // 探索其他模型部分
      exploreModelsTitle: '探索其他模型',
      runwayTitle: 'Runway Gen-4.5 AI 视频生成器',
      klingTitle: 'Kling 2.6 AI 视频生成器',
      veo31Title: 'Google Veo 3.1 AI 视频生成器',
      soraTitle: 'Sora 2 AI 视频生成器',

      // FAQ 部分
      faqTitle: '常见问题解答',
      faq1Question: 'WeryAI Video 1.0 是什么？',
      faq1Answer:
          'WeryAI Video 1.0 是 WeryAI 平台自主推出的旗舰级 AI 视频生成模型。它集成了我们最新的视觉生成技术，旨在为用户提供速度最快、叙事能力最强的视频创作体验。',
      faq2Question: 'WeryAI Video 1.0 主要能做什么？',
      faq2Answer:
          '它能将您的文字脚本或静态图片转化为生动的视频片段。它特别擅长处理电影级的镜头语言（如运镜切换）和复杂的物理动态，是制作短视频、广告片和动态壁纸的利器。',
      faq3Question: '在 WeryAI 上使用是免费的吗？',
      faq3Answer:
          '是的，作为平台福利，所有注册用户每天都可获得免费积分来体验 WeryAI Video 1.0。升级为 Pro 会员后，您将获得更快的生成通道和更多的每日额度。',
      faq4Question: '生成视频的质量和时长如何？',
      faq4Answer:
          'WeryAI Video 1.0 专注于生成高清（HD Optimized）的 5s、10s 的短视频。我们特别优化了画面结构，使其在移动端和网页端播放时极其清晰流畅。',
      faq5Question: '它和平台上的其他模型（如可灵、Luma）有什么区别？',
      faq5Answer:
          'WeryAI Video 1.0 是我们的原生模型，这意味着它在 WeryAI 平台上的响应速度最快、稳定性最高。相比其他第三方模型，它在"多镜头连续性"和"生成速度"上进行了专门优化，更适合追求效率的创作者。',

      // CTA 部分
      ctaTitle: '准备开始创作了吗？',
      ctaDescription: '立即体验 WeryAI Video 1.0，将您的创意转化为精彩视频',
      ctaButton: '开始创作',
      ctaDisclaimer: '无需信用卡 · 新用户免费体验',
  },
  en: {
      // Model name
      modelName: 'WeryAI Video 1.0',

      // Page title and description
      pageTitle: 'WeryAI Video 1.0 AI Video Generator - WeryAI Flagship AI Video Creation Tool',
      pageDescription:
          'WeryAI Video 1.0 is the flagship AI video generation model launched by WeryAI, featuring multi-shot narrative, intelligent image-to-video, ultra-fast rendering, and physics-level motion simulation. Try it free on WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, multi-shot narrative, image to video',

      // Generator section
      generatorTitle: 'WeryAI Video 1.0 Video Generator',
      generatorDescription:
          'WeryAI Video 1.0 is the flagship AI video generation model launched by WeryAI. It represents our ultimate pursuit of the perfect balance between "speed" and "artistry", featuring advanced semantic understanding and physics simulation engines, pioneering <span class="text-text-active">"native multi-shot narrative"</span> capability. <span class="text-text-active">Try it free on WeryAI video generator</span>!',

      // Tabs
      tabImageToVideo: 'Image to Video',
      tabTextToVideo: 'Text to Video',

      // Core features section
      coreFeaturesTitle: 'WeryAI Video 1.0 Core Features',
      coreFeaturesSubtitle: 'Explore the core features of WeryAI Video 1.0 and start your next-generation video creation journey',

      // Multi-shot narrative system
      multiShotTitle: 'Multi-Shot Narrative System',
      multiShotDescription:
          'The core breakthrough of WeryAI Video 1.0. It breaks the limitations of traditional single-shot generation, understanding and executing complex camera instructions (such as push, pull, pan, tilt, and transitions). The model ensures high consistency of character features and scene lighting during shot transitions, directly generating videos with complete narrative logic.',

      // Intelligent image-to-video engine
      imageToVideoTitle: 'Intelligent Image-to-Video Engine',
      imageToVideoDescription:
          'Bring static images to life. Simply upload a reference image, and WeryAI Video 1.0 can accurately identify the subject structure and add physics-compliant dynamic effects. Whether making a still person naturally blink and smile, or making water flow in a landscape painting, it achieves natural animation while preserving the original image quality.',

      // Ultra-fast rendering technology
      fastRenderTitle: 'Ultra-Fast Rendering Technology',
      fastRenderDescription:
          'Optimized for high-frequency creation. Thanks to WeryAI\'s unique model architecture optimization, Video 1.0\'s generation speed far exceeds industry averages. You can get 5-10 seconds of HD video clips in a very short time (typically 40-60 seconds), making creative iteration wait-free.',

      // Physics-level motion simulation
      physicsTitle: 'Physics-Level Motion Simulation',
      physicsDescription:
          'Reject the distortion caused by "AI hallucinations". Our model is trained on massive physics dynamics data with deep understanding of fluid, cloth, gravity and other physical rules. In generated videos, character movements are smooth and natural, and object collisions follow real-world logic.',

      // How to use section
      howToUseTitle: 'How to Use WeryAI Video 1.0',
      howToUseSubtitle: 'Three simple steps to get started',
      step1Title: 'Select Model',
      step1Description:
          'Select <span class="highlight-text">WeryAI Video 1.0</span> model in the AI video tool',
      step2Title: 'Enter Prompt',
      step2Description: 'Describe your creative story in the text box, or upload an image to enable "Image to Video" mode.',
      step3Title: 'Generate Video',
      step3Description: 'Select your target aspect ratio (16:9 cinematic or 9:16 portrait) and video duration, click "Generate", and preview and download your video masterpiece in moments.',

      // Explore other models section
      exploreModelsTitle: 'Explore Other Models',
      runwayTitle: 'Runway Gen-4.5 AI Video Generator',
      klingTitle: 'Kling 2.6 AI Video Generator',
      veo31Title: 'Google Veo 3.1 AI Video Generator',
      soraTitle: 'Sora 2 AI Video Generator',

      // FAQ section
      faqTitle: 'Frequently Asked Questions',
      faq1Question: 'What is WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 is the flagship AI video generation model independently launched by WeryAI. It integrates our latest visual generation technology, designed to provide users with the fastest speed and strongest narrative capabilities for video creation.',
      faq2Question: 'What can WeryAI Video 1.0 do?',
      faq2Answer:
          'It can transform your text scripts or static images into vivid video clips. It excels at handling cinematic camera language (such as camera movements and transitions) and complex physical dynamics, making it perfect for creating short videos, advertisements, and animated wallpapers.',
      faq3Question: 'Is it free to use on WeryAI?',
      faq3Answer:
          'Yes, as a platform benefit, all registered users receive free credits daily to experience WeryAI Video 1.0. Upgrading to Pro membership gives you faster generation channels and more daily quota.',
      faq4Question: 'What is the quality and duration of generated videos?',
      faq4Answer:
          'WeryAI Video 1.0 focuses on generating HD Optimized short videos of 5s and 10s. We have specially optimized the visual structure for crystal-clear and smooth playback on both mobile and web platforms.',
      faq5Question: 'How is it different from other models on the platform (like Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 is our native model, meaning it has the fastest response speed and highest stability on the WeryAI platform. Compared to other third-party models, it is specially optimized for "multi-shot continuity" and "generation speed", making it more suitable for efficiency-focused creators.',

      // CTA section
      ctaTitle: 'Ready to Start Creating?',
      ctaDescription: 'Experience WeryAI Video 1.0 now and transform your creativity into amazing videos',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required · Free trial for new users',
  },
  ja: {
      // モデル名
      modelName: 'WeryAI Video 1.0',

      // ページタイトルと説明
      pageTitle: 'WeryAI Video 1.0 AI動画ジェネレーター - WeryAI旗艦級AI動画作成ツール',
      pageDescription:
          'WeryAI Video 1.0はWeryAIプラットフォームが提供する旗艦級AI動画生成モデルで、マルチショット叙事、インテリジェント画像to動画、超高速レンダリング、物理レベルモーションシミュレーションなどのコア機能を備えています。WeryAIで無料でお試しください。',
      pageKeywords:
          'WeryAI Video 1.0, AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, WeryAI, マルチショット叙事, 画像to動画',

      // ジェネレーター部分
      generatorTitle: 'WeryAI Video 1.0 動画ジェネレーター',
      generatorDescription:
          'WeryAI Video 1.0はWeryAIプラットフォームが提供する旗艦級AI動画生成モデルです。「スピード」と「芸術性」の完璧なバランスを追求し、先進的なセマンティック理解と物理シミュレーションエンジンを搭載、<span class="text-text-active">「ネイティブマルチショット叙事」</span>機能を実現。<span class="text-text-active">WeryAI動画ジェネレーターで無料でお試しください</span>！',

      // タブ
      tabImageToVideo: '画像から動画',
      tabTextToVideo: 'テキストから動画',

      // コア機能部分
      coreFeaturesTitle: 'WeryAI Video 1.0 コア機能',
      coreFeaturesSubtitle: 'WeryAI Video 1.0のコア機能を探索し、次世代の動画作成の旅を始めましょう',

      // マルチショット叙事システム
      multiShotTitle: 'マルチショット叙事システム',
      multiShotDescription:
          'WeryAI Video 1.0のコアブレークスルー。従来のシングルショット生成の制限を打破し、複雑なカメラ指示（プッシュ、プル、パン、ティルト、トランジションなど）を理解し実行できます。ショット切り替え時にキャラクターの特徴とシーンライティングの高い一貫性を確保し、完全な叙事ロジックを持つ動画を直接生成します。',

      // インテリジェント画像to動画エンジン
      imageToVideoTitle: 'インテリジェント画像to動画エンジン',
      imageToVideoDescription:
          '静止画像に命を吹き込みます。参照画像をアップロードするだけで、WeryAI Video 1.0は主体構造を正確に識別し、物理法則に準拠した動的効果を追加できます。静止した人物を自然にまばたきさせたり微笑ませたり、風景画の水を流れさせたりと、元の画質を維持しながら自然なアニメーション化を実現します。',

      // 超高速レンダリング技術
      fastRenderTitle: '超高速レンダリング技術',
      fastRenderDescription:
          '高頻度クリエイション向けに最適化。WeryAI独自のモデルアーキテクチャ最適化により、Video 1.0の生成速度は業界平均を大幅に上回ります。非常に短い時間（通常40-60秒）で5-10秒のHD動画クリップを取得でき、クリエイティブなイテレーションを待ち時間なしで実現します。',

      // 物理レベルモーションシミュレーション
      physicsTitle: '物理レベルモーションシミュレーション',
      physicsDescription:
          '「AIハルシネーション」による崩壊感を拒否。我々のモデルは大量の物理動態データでトレーニングされ、流体、布、重力などの物理ルールを深く理解しています。生成された動画では、キャラクターの動きは滑らかで自然、物体の衝突は現実世界のロジックに従います。',

      // 使用方法部分
      howToUseTitle: 'WeryAI Video 1.0の使い方',
      howToUseSubtitle: '簡単3ステップで開始',
      step1Title: 'モデル選択',
      step1Description:
          'AI動画ツールで<span class="highlight-text">WeryAI Video 1.0</span>モデルを選択',
      step2Title: 'プロンプト入力',
      step2Description: 'テキストボックスにクリエイティブなストーリーを記述するか、画像をアップロードして「画像to動画」モードを有効にします。',
      step3Title: '動画生成',
      step3Description: '目標アスペクト比（16:9シネマティックまたは9:16ポートレート）と動画時間を選択し、「生成」をクリックすると、すぐに動画の傑作をプレビュー・ダウンロードできます。',

      // 他のモデル探索部分
      exploreModelsTitle: '他のモデルを探索',
      runwayTitle: 'Runway Gen-4.5 AI動画ジェネレーター',
      klingTitle: 'Kling 2.6 AI動画ジェネレーター',
      veo31Title: 'Google Veo 3.1 AI動画ジェネレーター',
      soraTitle: 'Sora 2 AI動画ジェネレーター',

      // FAQ部分
      faqTitle: 'よくある質問',
      faq1Question: 'WeryAI Video 1.0とは何ですか？',
      faq1Answer:
          'WeryAI Video 1.0はWeryAIが独自に提供する旗艦級AI動画生成モデルです。最新のビジュアル生成技術を統合し、ユーザーに最速かつ最強の叙事能力を持つ動画作成体験を提供することを目指しています。',
      faq2Question: 'WeryAI Video 1.0で何ができますか？',
      faq2Answer:
          'テキストスクリプトや静止画像を生き生きとした動画クリップに変換できます。シネマティックなカメラ言語（カメラワークやトランジションなど）と複雑な物理動態の処理に優れており、ショート動画、広告、アニメーション壁紙の作成に最適です。',
      faq3Question: 'WeryAIで無料で使用できますか？',
      faq3Answer:
          'はい、プラットフォーム特典として、すべての登録ユーザーはWeryAI Video 1.0を体験するための無料クレジットを毎日受け取れます。Proメンバーシップにアップグレードすると、より速い生成チャンネルとより多くの日次クォータが得られます。',
      faq4Question: '生成される動画の品質と長さはどうですか？',
      faq4Answer:
          'WeryAI Video 1.0は、5秒・10秒のHD最適化ショート動画の生成に特化しています。モバイルとウェブの両方で非常にクリアでスムーズに再生できるよう、映像構造を特別に最適化しました。',
      faq5Question: 'プラットフォーム上の他のモデル（Kling、Lumaなど）とどう違いますか？',
      faq5Answer:
          'WeryAI Video 1.0は我々のネイティブモデルであり、WeryAIプラットフォームで最速の応答速度と最高の安定性を持っています。他のサードパーティモデルと比較して、「マルチショット連続性」と「生成速度」に特化した最適化が行われており、効率を重視するクリエイターに適しています。',

      // CTA部分
      ctaTitle: '作成を始める準備はできましたか？',
      ctaDescription: '今すぐWeryAI Video 1.0を体験し、あなたの創造性を素晴らしい動画に変換',
      ctaButton: '創作を開始',
      ctaDisclaimer: 'クレジットカード不要 · 新規ユーザー無料体験',
  },
  ko: {
      // 모델 이름
      modelName: 'WeryAI Video 1.0',

      // 페이지 제목과 설명
      pageTitle: 'WeryAI Video 1.0 AI 비디오 생성기 - WeryAI 플래그십 AI 비디오 제작 도구',
      pageDescription:
          'WeryAI Video 1.0은 WeryAI 플랫폼이 출시한 플래그십 AI 비디오 생성 모델로, 멀티샷 내러티브, 지능형 이미지-투-비디오, 초고속 렌더링, 물리 수준 모션 시뮬레이션 등의 핵심 기능을 갖추고 있습니다. WeryAI에서 무료로 체험하세요.',
      pageKeywords:
          'WeryAI Video 1.0, AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, WeryAI, 멀티샷 내러티브, 이미지 투 비디오',

      // 생성기 부분
      generatorTitle: 'WeryAI Video 1.0 비디오 생성기',
      generatorDescription:
          'WeryAI Video 1.0은 WeryAI 플랫폼이 출시한 플래그십 AI 비디오 생성 모델입니다. "속도"와 "예술성"의 완벽한 균형을 추구하며, 고급 의미 이해와 물리 시뮬레이션 엔진을 탑재하고 <span class="text-text-active">"네이티브 멀티샷 내러티브"</span> 기능을 선보입니다. <span class="text-text-active">WeryAI 비디오 생성기에서 무료로 체험하세요</span>!',

      // 탭
      tabImageToVideo: '이미지에서 비디오',
      tabTextToVideo: '텍스트에서 비디오',

      // 핵심 기능 부분
      coreFeaturesTitle: 'WeryAI Video 1.0 핵심 기능',
      coreFeaturesSubtitle: 'WeryAI Video 1.0의 핵심 기능을 탐색하고 차세대 비디오 제작 여정을 시작하세요',

      // 멀티샷 내러티브 시스템
      multiShotTitle: '멀티샷 내러티브 시스템',
      multiShotDescription:
          'WeryAI Video 1.0의 핵심 돌파구입니다. 전통적인 단일 샷 생성의 한계를 깨고 복잡한 카메라 지시(푸시, 풀, 팬, 틸트, 트랜지션 등)를 이해하고 실행할 수 있습니다. 샷 전환 시 캐릭터 특징과 장면 조명의 높은 일관성을 보장하며, 완전한 내러티브 로직을 가진 비디오를 직접 생성합니다.',

      // 지능형 이미지-투-비디오 엔진
      imageToVideoTitle: '지능형 이미지-투-비디오 엔진',
      imageToVideoDescription:
          '정지 이미지에 생명을 불어넣습니다. 참조 이미지를 업로드하기만 하면 WeryAI Video 1.0이 주체 구조를 정확하게 식별하고 물리 법칙에 맞는 동적 효과를 추가할 수 있습니다. 정지된 인물을 자연스럽게 눈 깜빡이게 하거나 미소 짓게 하거나, 풍경화의 물을 흐르게 하는 등 원본 이미지 품질을 유지하면서 자연스러운 애니메이션화를 실현합니다.',

      // 초고속 렌더링 기술
      fastRenderTitle: '초고속 렌더링 기술',
      fastRenderDescription:
          '고빈도 창작에 최적화되었습니다. WeryAI의 고유한 모델 아키텍처 최적화 덕분에 Video 1.0의 생성 속도는 업계 평균을 훨씬 능가합니다. 매우 짧은 시간(보통 40-60초) 내에 5-10초의 HD 비디오 클립을 얻을 수 있어 창의적 반복이 대기 없이 가능합니다.',

      // 물리 수준 모션 시뮬레이션
      physicsTitle: '물리 수준 모션 시뮬레이션',
      physicsDescription:
          '"AI 환각"으로 인한 왜곡을 거부합니다. 우리 모델은 방대한 물리 역학 데이터로 훈련되어 유체, 천, 중력 등 물리 규칙에 대한 깊은 이해를 가지고 있습니다. 생성된 비디오에서 캐릭터 움직임은 부드럽고 자연스러우며, 물체 충돌은 실제 세계 논리를 따릅니다.',

      // 사용 방법 부분
      howToUseTitle: 'WeryAI Video 1.0 사용 방법',
      howToUseSubtitle: '간단한 3단계로 시작',
      step1Title: '모델 선택',
      step1Description:
          'AI 비디오 도구에서 <span class="highlight-text">WeryAI Video 1.0</span> 모델 선택',
      step2Title: '프롬프트 입력',
      step2Description: '텍스트 상자에 창의적인 스토리를 설명하거나 이미지를 업로드하여 "이미지-투-비디오" 모드를 활성화합니다.',
      step3Title: '비디오 생성',
      step3Description: '목표 화면 비율(16:9 시네마틱 또는 9:16 세로) 및 비디오 길이를 선택하고 "생성"을 클릭하면 곧 비디오 걸작을 미리보고 다운로드할 수 있습니다.',

      // 다른 모델 탐색 부분
      exploreModelsTitle: '다른 모델 탐색',
      runwayTitle: 'Runway Gen-4.5 AI 비디오 생성기',
      klingTitle: 'Kling 2.6 AI 비디오 생성기',
      veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
      soraTitle: 'Sora 2 AI 비디오 생성기',

      // FAQ 부분
      faqTitle: '자주 묻는 질문',
      faq1Question: 'WeryAI Video 1.0이란 무엇인가요?',
      faq1Answer:
          'WeryAI Video 1.0은 WeryAI가 독자적으로 출시한 플래그십 AI 비디오 생성 모델입니다. 최신 시각 생성 기술을 통합하여 사용자에게 가장 빠른 속도와 가장 강력한 내러티브 능력의 비디오 제작 경험을 제공하는 것을 목표로 합니다.',
      faq2Question: 'WeryAI Video 1.0으로 무엇을 할 수 있나요?',
      faq2Answer:
          '텍스트 스크립트나 정지 이미지를 생생한 비디오 클립으로 변환할 수 있습니다. 시네마틱 카메라 언어(카메라 움직임 및 전환 등)와 복잡한 물리 역학 처리에 뛰어나 짧은 비디오, 광고, 애니메이션 배경화면 제작에 완벽합니다.',
      faq3Question: 'WeryAI에서 무료로 사용할 수 있나요?',
      faq3Answer:
          '네, 플랫폼 혜택으로 모든 등록 사용자는 WeryAI Video 1.0을 체험하기 위한 무료 크레딧을 매일 받습니다. Pro 멤버십으로 업그레이드하면 더 빠른 생성 채널과 더 많은 일일 할당량을 얻을 수 있습니다.',
      faq4Question: '생성되는 비디오의 품질과 길이는 어떤가요?',
      faq4Answer:
          'WeryAI Video 1.0은 5초, 10초의 HD 최적화 짧은 영상 생성에 집중합니다. 모바일과 웹에서 매우 선명하고 부드럽게 재생될 수 있도록 화면 구조를 특별히 최적화했습니다.',
      faq5Question: '플랫폼의 다른 모델(Kling, Luma 등)과 어떻게 다른가요?',
      faq5Answer:
          'WeryAI Video 1.0은 네이티브 모델로, WeryAI 플랫폼에서 가장 빠른 응답 속도와 가장 높은 안정성을 가지고 있습니다. 다른 서드파티 모델과 비교하여 "멀티샷 연속성"과 "생성 속도"에 특별히 최적화되어 효율을 중시하는 크리에이터에게 더 적합합니다.',

      // CTA 부분
      ctaTitle: '제작을 시작할 준비가 되셨나요?',
      ctaDescription: '지금 WeryAI Video 1.0을 체험하고 창의성을 놀라운 비디오로 변환하세요',
      ctaButton: '창작 시작',
      ctaDisclaimer: '신용카드 불필요 · 신규 사용자 무료 체험',
  },
  es: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'Generador de videos IA WeryAI Video 1.0 - Herramienta insignia de creación de videos IA | WeryAI',
      pageDescription:
          'WeryAI Video 1.0 es el modelo insignia de generación de video IA lanzado por WeryAI, con narrativa multi-toma, imagen a video inteligente, renderizado ultrarrápido y simulación de movimiento a nivel físico. Pruébalo gratis en WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, generador de video IA, creación de video IA, video inteligencia artificial, herramienta de generación de video, video IA gratis, WeryAI, narrativa multi-toma, imagen a video',

      generatorTitle: 'Generador de videos WeryAI Video 1.0',
      generatorDescription:
          'WeryAI Video 1.0 es el modelo insignia de generación de video IA lanzado por WeryAI. Representa nuestra búsqueda del equilibrio perfecto entre "velocidad" y "arte", con motores avanzados de comprensión semántica y simulación física, pionero en la capacidad de <span class="text-text-active">"narrativa multi-toma nativa"</span>. <span class="text-text-active">¡Pruébalo gratis en el generador de video WeryAI</span>!',

      tabImageToVideo: 'Imagen a video',
      tabTextToVideo: 'Texto a video',

      coreFeaturesTitle: 'Funciones principales de WeryAI Video 1.0',
      coreFeaturesSubtitle: 'Explora las funciones principales de WeryAI Video 1.0 y comienza tu viaje de creación de video de próxima generación',

      multiShotTitle: 'Sistema de narrativa multi-toma',
      multiShotDescription:
          'El avance central de WeryAI Video 1.0. Rompe las limitaciones de la generación de toma única tradicional, comprendiendo y ejecutando instrucciones de cámara complejas (como push, pull, pan, tilt y transiciones). El modelo asegura alta consistencia de características de personajes e iluminación de escenas durante las transiciones de toma, generando directamente videos con lógica narrativa completa.',

      imageToVideoTitle: 'Motor inteligente de imagen a video',
      imageToVideoDescription:
          'Da vida a las imágenes estáticas. Simplemente sube una imagen de referencia y WeryAI Video 1.0 puede identificar con precisión la estructura del sujeto y agregar efectos dinámicos que cumplen con la física. Ya sea hacer que una persona quieta parpadee y sonría naturalmente, o hacer que el agua fluya en un paisaje, logra animación natural mientras preserva la calidad original de la imagen.',

      fastRenderTitle: 'Tecnología de renderizado ultrarrápido',
      fastRenderDescription:
          'Optimizado para creación de alta frecuencia. Gracias a la optimización única de arquitectura del modelo de WeryAI, la velocidad de generación de Video 1.0 supera con creces los promedios de la industria. Puedes obtener clips de video HD de 5-10 segundos en muy poco tiempo (típicamente 40-60 segundos), haciendo que la iteración creativa no tenga esperas.',

      physicsTitle: 'Simulación de movimiento a nivel físico',
      physicsDescription:
          'Rechaza la distorsión causada por "alucinaciones de IA". Nuestro modelo está entrenado con datos masivos de dinámica física con comprensión profunda de fluidos, telas, gravedad y otras reglas físicas. En los videos generados, los movimientos de los personajes son suaves y naturales, y las colisiones de objetos siguen la lógica del mundo real.',

      howToUseTitle: 'Cómo usar WeryAI Video 1.0',
      howToUseSubtitle: 'Tres simples pasos para comenzar',
      step1Title: 'Seleccionar modelo',
      step1Description: 'Selecciona el modelo <span class="highlight-text">WeryAI Video 1.0</span> en la herramienta de video IA',
      step2Title: 'Ingresar prompt',
      step2Description: 'Describe tu historia creativa en el cuadro de texto, o sube una imagen para habilitar el modo "Imagen a video".',
      step3Title: 'Generar video',
      step3Description: 'Selecciona tu relación de aspecto objetivo (16:9 cinemático o 9:16 vertical) y duración del video, haz clic en "Generar" y previsualiza y descarga tu obra maestra de video en momentos.',

      exploreModelsTitle: 'Explorar otros modelos',
      runwayTitle: 'Generador de video IA Runway Gen-4.5',
      klingTitle: 'Generador de video IA Kling 2.6',
      veo31Title: 'Generador de video IA Google Veo 3.1',
      soraTitle: 'Generador de video IA Sora 2',

      faqTitle: 'Preguntas frecuentes',
      faq1Question: '¿Qué es WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 es el modelo insignia de generación de video IA lanzado independientemente por WeryAI. Integra nuestra última tecnología de generación visual, diseñada para proporcionar a los usuarios la velocidad más rápida y las capacidades narrativas más fuertes para la creación de video.',
      faq2Question: '¿Qué puede hacer WeryAI Video 1.0?',
      faq2Answer:
          'Puede transformar tus scripts de texto o imágenes estáticas en clips de video vívidos. Sobresale en el manejo de lenguaje de cámara cinemático (como movimientos de cámara y transiciones) y dinámica física compleja, siendo perfecto para crear videos cortos, anuncios y fondos animados.',
      faq3Question: '¿Es gratis usarlo en WeryAI?',
      faq3Answer:
          'Sí, como beneficio de la plataforma, todos los usuarios registrados reciben créditos gratuitos diarios para experimentar WeryAI Video 1.0. Actualizar a membresía Pro te da canales de generación más rápidos y más cuota diaria.',
      faq4Question: '¿Cuál es la calidad y duración de los videos generados?',
      faq4Answer:
          'WeryAI Video 1.0 se centra en generar vídeos cortos de 5s y 10s optimizados en HD. Hemos optimizado especialmente la estructura visual para una reproducción nítida y fluida tanto en dispositivos móviles como en navegadores web.',
      faq5Question: '¿En qué se diferencia de otros modelos en la plataforma (como Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 es nuestro modelo nativo, lo que significa que tiene la velocidad de respuesta más rápida y la mayor estabilidad en la plataforma WeryAI. Comparado con otros modelos de terceros, está especialmente optimizado para "continuidad multi-toma" y "velocidad de generación", siendo más adecuado para creadores enfocados en eficiencia.',

      ctaTitle: '¿Listo para empezar a crear?',
      ctaDescription: 'Experimenta WeryAI Video 1.0 ahora y transforma tu creatividad en videos increíbles',
      ctaButton: 'Comenzar a crear',
      ctaDisclaimer: 'No se requiere tarjeta de crédito · Prueba gratuita para nuevos usuarios',
  },
  fr: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'Générateur vidéo IA WeryAI Video 1.0 - Outil phare de création vidéo IA | WeryAI',
      pageDescription:
          'WeryAI Video 1.0 est le modèle phare de génération vidéo IA lancé par WeryAI, avec narration multi-plans, image vers vidéo intelligent, rendu ultra-rapide et simulation de mouvement au niveau physique. Essayez-le gratuitement sur WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, générateur vidéo IA, création vidéo IA, vidéo intelligence artificielle, outil de génération vidéo, vidéo IA gratuite, WeryAI, narration multi-plans, image vers vidéo',

      generatorTitle: 'Générateur vidéo WeryAI Video 1.0',
      generatorDescription:
          'WeryAI Video 1.0 est le modèle phare de génération vidéo IA lancé par WeryAI. Il représente notre quête de l\'équilibre parfait entre "vitesse" et "art", avec des moteurs avancés de compréhension sémantique et de simulation physique, pionnier de la capacité de <span class="text-text-active">"narration multi-plans native"</span>. <span class="text-text-active">Essayez-le gratuitement sur le générateur vidéo WeryAI</span>!',

      tabImageToVideo: 'Image vers vidéo',
      tabTextToVideo: 'Texte vers vidéo',

      coreFeaturesTitle: 'Fonctionnalités principales de WeryAI Video 1.0',
      coreFeaturesSubtitle: 'Explorez les fonctionnalités principales de WeryAI Video 1.0 et commencez votre voyage de création vidéo de nouvelle génération',

      multiShotTitle: 'Système de narration multi-plans',
      multiShotDescription:
          'La percée centrale de WeryAI Video 1.0. Il brise les limitations de la génération de plan unique traditionnelle, comprenant et exécutant des instructions de caméra complexes (comme push, pull, pan, tilt et transitions). Le modèle assure une haute cohérence des caractéristiques des personnages et de l\'éclairage des scènes lors des transitions de plans, générant directement des vidéos avec une logique narrative complète.',

      imageToVideoTitle: 'Moteur intelligent image vers vidéo',
      imageToVideoDescription:
          'Donnez vie aux images statiques. Téléchargez simplement une image de référence et WeryAI Video 1.0 peut identifier avec précision la structure du sujet et ajouter des effets dynamiques conformes à la physique. Que ce soit faire cligner des yeux et sourire naturellement une personne immobile, ou faire couler l\'eau dans un paysage, il réalise une animation naturelle tout en préservant la qualité originale de l\'image.',

      fastRenderTitle: 'Technologie de rendu ultra-rapide',
      fastRenderDescription:
          'Optimisé pour la création haute fréquence. Grâce à l\'optimisation unique de l\'architecture du modèle WeryAI, la vitesse de génération de Video 1.0 dépasse largement les moyennes de l\'industrie. Vous pouvez obtenir des clips vidéo HD de 5-10 secondes en très peu de temps (typiquement 40-60 secondes), rendant l\'itération créative sans attente.',

      physicsTitle: 'Simulation de mouvement au niveau physique',
      physicsDescription:
          'Rejetez la distorsion causée par les "hallucinations IA". Notre modèle est entraîné sur des données massives de dynamique physique avec une compréhension profonde des fluides, tissus, gravité et autres règles physiques. Dans les vidéos générées, les mouvements des personnages sont fluides et naturels, et les collisions d\'objets suivent la logique du monde réel.',

      howToUseTitle: 'Comment utiliser WeryAI Video 1.0',
      howToUseSubtitle: 'Trois étapes simples pour commencer',
      step1Title: 'Sélectionner le modèle',
      step1Description: 'Sélectionnez le modèle <span class="highlight-text">WeryAI Video 1.0</span> dans l\'outil vidéo IA',
      step2Title: 'Entrer le prompt',
      step2Description: 'Décrivez votre histoire créative dans la zone de texte, ou téléchargez une image pour activer le mode "Image vers vidéo".',
      step3Title: 'Générer la vidéo',
      step3Description: 'Sélectionnez votre rapport d\'aspect cible (16:9 cinématique ou 9:16 portrait) et la durée de la vidéo, cliquez sur "Générer" et prévisualisez et téléchargez votre chef-d\'œuvre vidéo en quelques instants.',

      exploreModelsTitle: 'Explorer d\'autres modèles',
      runwayTitle: 'Générateur vidéo IA Runway Gen-4.5',
      klingTitle: 'Générateur vidéo IA Kling 2.6',
      veo31Title: 'Générateur vidéo IA Google Veo 3.1',
      soraTitle: 'Générateur vidéo IA Sora 2',

      faqTitle: 'Questions fréquentes',
      faq1Question: 'Qu\'est-ce que WeryAI Video 1.0 ?',
      faq1Answer:
          'WeryAI Video 1.0 est le modèle phare de génération vidéo IA lancé indépendamment par WeryAI. Il intègre notre dernière technologie de génération visuelle, conçue pour offrir aux utilisateurs la vitesse la plus rapide et les capacités narratives les plus fortes pour la création vidéo.',
      faq2Question: 'Que peut faire WeryAI Video 1.0 ?',
      faq2Answer:
          'Il peut transformer vos scripts texte ou images statiques en clips vidéo vivants. Il excelle dans le traitement du langage caméra cinématique (comme les mouvements de caméra et les transitions) et la dynamique physique complexe, parfait pour créer des vidéos courtes, des publicités et des fonds d\'écran animés.',
      faq3Question: 'Est-ce gratuit sur WeryAI ?',
      faq3Answer:
          'Oui, en tant qu\'avantage de la plateforme, tous les utilisateurs inscrits reçoivent des crédits gratuits quotidiens pour expérimenter WeryAI Video 1.0. La mise à niveau vers l\'abonnement Pro vous donne des canaux de génération plus rapides et plus de quota quotidien.',
      faq4Question: 'Quelle est la qualité et la durée des vidéos générées ?',
      faq4Answer:
          'WeryAI Video 1.0 se concentre sur la génération de vidéos courtes de 5s et 10s optimisées en HD. Nous avons spécialement optimisé la structure visuelle pour une lecture ultra-nette et fluide sur mobile et web.',
      faq5Question: 'En quoi est-il différent des autres modèles de la plateforme (comme Kling, Luma) ?',
      faq5Answer:
          'WeryAI Video 1.0 est notre modèle natif, ce qui signifie qu\'il a la vitesse de réponse la plus rapide et la plus grande stabilité sur la plateforme WeryAI. Comparé aux autres modèles tiers, il est spécialement optimisé pour la "continuité multi-plans" et la "vitesse de génération", le rendant plus adapté aux créateurs axés sur l\'efficacité.',

      ctaTitle: 'Prêt à commencer à créer ?',
      ctaDescription: 'Découvrez WeryAI Video 1.0 maintenant et transformez votre créativité en vidéos incroyables',
      ctaButton: 'Commencer à créer',
      ctaDisclaimer: 'Aucune carte bancaire requise · Essai gratuit pour les nouveaux utilisateurs',
  },
  de: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'WeryAI Video 1.0 KI-Videogenerator - WeryAI Flaggschiff KI-Videoerstellungstool',
      pageDescription:
          'WeryAI Video 1.0 ist das Flaggschiff KI-Videogenerierungsmodell von WeryAI mit Multi-Shot-Narration, intelligentem Bild-zu-Video, ultraschnellem Rendering und physikbasierter Bewegungssimulation. Testen Sie es kostenlos auf WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, KI-Videogenerator, KI-Videoerstellung, künstliche Intelligenz Video, Videogenerierungstool, kostenloses KI-Video, WeryAI, Multi-Shot-Narration, Bild zu Video',

      generatorTitle: 'WeryAI Video 1.0 Videogenerator',
      generatorDescription:
          'WeryAI Video 1.0 ist das Flaggschiff KI-Videogenerierungsmodell von WeryAI. Es repräsentiert unser Streben nach der perfekten Balance zwischen "Geschwindigkeit" und "Kunst", mit fortschrittlichen Semantikverständnis- und Physiksimulationsmotoren, Pionier der <span class="text-text-active">"nativen Multi-Shot-Narration"</span>. <span class="text-text-active">Testen Sie es kostenlos im WeryAI-Videogenerator</span>!',

      tabImageToVideo: 'Bild zu Video',
      tabTextToVideo: 'Text zu Video',

      coreFeaturesTitle: 'WeryAI Video 1.0 Kernfunktionen',
      coreFeaturesSubtitle: 'Entdecken Sie die Kernfunktionen von WeryAI Video 1.0 und starten Sie Ihre Videoerstellungsreise der nächsten Generation',

      multiShotTitle: 'Multi-Shot-Narrativsystem',
      multiShotDescription:
          'Der Kerndurchbruch von WeryAI Video 1.0. Es durchbricht die Grenzen der traditionellen Einzelschussgenerierung und versteht und führt komplexe Kameraanweisungen aus (wie Push, Pull, Pan, Tilt und Übergänge). Das Modell gewährleistet hohe Konsistenz von Charaktermerkmalen und Szenenbeleuchtung während Schnittübergängen und generiert direkt Videos mit vollständiger Narrativlogik.',

      imageToVideoTitle: 'Intelligenter Bild-zu-Video-Motor',
      imageToVideoDescription:
          'Hauchen Sie statischen Bildern Leben ein. Laden Sie einfach ein Referenzbild hoch und WeryAI Video 1.0 kann die Subjektstruktur genau identifizieren und physikkonforme dynamische Effekte hinzufügen. Ob eine stille Person natürlich blinzeln und lächeln lassen oder Wasser in einer Landschaft fließen lassen - es erreicht natürliche Animation bei Erhalt der ursprünglichen Bildqualität.',

      fastRenderTitle: 'Ultraschnelle Rendering-Technologie',
      fastRenderDescription:
          'Optimiert für hochfrequente Erstellung. Dank WeryAIs einzigartiger Modellarchitekturoptimierung übertrifft die Generierungsgeschwindigkeit von Video 1.0 die Branchendurchschnitte bei weitem. Sie können in sehr kurzer Zeit (typischerweise 40-60 Sekunden) 5-10 Sekunden HD-Videoclips erhalten und kreative Iteration ohne Wartezeit ermöglichen.',

      physicsTitle: 'Physikbasierte Bewegungssimulation',
      physicsDescription:
          'Lehnen Sie die durch "KI-Halluzinationen" verursachte Verzerrung ab. Unser Modell ist mit massiven Physikdynamikdaten trainiert und hat ein tiefes Verständnis von Flüssigkeiten, Stoffen, Schwerkraft und anderen physikalischen Regeln. In generierten Videos sind Charakterbewegungen glatt und natürlich, und Objektkollisionen folgen der Logik der realen Welt.',

      howToUseTitle: 'So verwenden Sie WeryAI Video 1.0',
      howToUseSubtitle: 'Drei einfache Schritte zum Starten',
      step1Title: 'Modell auswählen',
      step1Description: 'Wählen Sie das <span class="highlight-text">WeryAI Video 1.0</span> Modell im KI-Video-Tool',
      step2Title: 'Prompt eingeben',
      step2Description: 'Beschreiben Sie Ihre kreative Geschichte im Textfeld oder laden Sie ein Bild hoch, um den "Bild-zu-Video"-Modus zu aktivieren.',
      step3Title: 'Video generieren',
      step3Description: 'Wählen Sie Ihr Ziel-Seitenverhältnis (16:9 kinematisch oder 9:16 Hochformat) und Videolänge, klicken Sie auf "Generieren" und schauen Sie sich Ihr Video-Meisterwerk in Kürze an und laden Sie es herunter.',

      exploreModelsTitle: 'Weitere Modelle erkunden',
      runwayTitle: 'Runway Gen-4.5 KI-Videogenerator',
      klingTitle: 'Kling 2.6 KI-Videogenerator',
      veo31Title: 'Google Veo 3.1 KI-Videogenerator',
      soraTitle: 'Sora 2 KI-Videogenerator',

      faqTitle: 'Häufig gestellte Fragen',
      faq1Question: 'Was ist WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 ist das Flaggschiff KI-Videogenerierungsmodell, das unabhängig von WeryAI eingeführt wurde. Es integriert unsere neueste visuelle Generierungstechnologie, die Benutzern die schnellste Geschwindigkeit und stärksten Narrativfähigkeiten für die Videoerstellung bieten soll.',
      faq2Question: 'Was kann WeryAI Video 1.0?',
      faq2Answer:
          'Es kann Ihre Textskripte oder statischen Bilder in lebendige Videoclips verwandeln. Es zeichnet sich durch die Verarbeitung von kinematischer Kamerasprache (wie Kamerabewegungen und Übergänge) und komplexer physikalischer Dynamik aus und ist perfekt für die Erstellung von Kurzvideos, Werbung und animierten Hintergründen.',
      faq3Question: 'Ist es kostenlos auf WeryAI zu nutzen?',
      faq3Answer:
          'Ja, als Plattformvorteil erhalten alle registrierten Benutzer täglich kostenlose Credits, um WeryAI Video 1.0 zu erleben. Ein Upgrade auf die Pro-Mitgliedschaft gibt Ihnen schnellere Generierungskanäle und mehr tägliches Kontingent.',
      faq4Question: 'Welche Qualität und Länge haben die generierten Videos?',
      faq4Answer:
          'WeryAI Video 1.0 konzentriert sich auf die Erstellung von HD-optimierten Kurzvideos mit 5s und 10s Länge. Wir haben die Bildstruktur speziell für eine kristallklare und flüssige Wiedergabe auf Mobilgeräten und im Web optimiert.',
      faq5Question: 'Wie unterscheidet es sich von anderen Modellen auf der Plattform (wie Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 ist unser natives Modell, was bedeutet, dass es die schnellste Antwortgeschwindigkeit und höchste Stabilität auf der WeryAI-Plattform hat. Im Vergleich zu anderen Drittanbietermodellen ist es speziell für "Multi-Shot-Kontinuität" und "Generierungsgeschwindigkeit" optimiert und eignet sich besser für effizienzorientierte Kreative.',

      ctaTitle: 'Bereit, mit dem Erstellen zu beginnen?',
      ctaDescription: 'Erleben Sie WeryAI Video 1.0 jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
      ctaButton: 'Erstellung starten',
      ctaDisclaimer: 'Keine Kreditkarte erforderlich · Kostenlose Testversion für neue Benutzer',
  },
  ru: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'Генератор видео WeryAI Video 1.0 - Флагманский инструмент создания видео с ИИ | WeryAI',
      pageDescription:
          'WeryAI Video 1.0 — флагманская модель генерации видео с ИИ от WeryAI, с мультикадровым повествованием, интеллектуальным преобразованием изображения в видео, сверхбыстрым рендерингом и симуляцией движения на физическом уровне. Попробуйте бесплатно на WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, генератор видео ИИ, создание видео с ИИ, видео искусственный интеллект, инструмент генерации видео, бесплатное ИИ видео, WeryAI, мультикадровое повествование, изображение в видео',

      generatorTitle: 'Генератор видео WeryAI Video 1.0',
      generatorDescription:
          'WeryAI Video 1.0 — флагманская модель генерации видео с ИИ от WeryAI. Она представляет наше стремление к идеальному балансу между "скоростью" и "художественностью", с передовыми движками семантического понимания и физической симуляции, пионер в возможности <span class="text-text-active">"нативного мультикадрового повествования"</span>. <span class="text-text-active">Попробуйте бесплатно в генераторе видео WeryAI</span>!',

      tabImageToVideo: 'Изображение в видео',
      tabTextToVideo: 'Текст в видео',

      coreFeaturesTitle: 'Основные функции WeryAI Video 1.0',
      coreFeaturesSubtitle: 'Изучите основные функции WeryAI Video 1.0 и начните свой путь создания видео нового поколения',

      multiShotTitle: 'Система мультикадрового повествования',
      multiShotDescription:
          'Ключевой прорыв WeryAI Video 1.0. Преодолевает ограничения традиционной однокадровой генерации, понимая и выполняя сложные указания камеры (такие как наезд, отъезд, панорамирование, наклон и переходы). Модель обеспечивает высокую согласованность характеристик персонажей и освещения сцены при смене кадров, напрямую генерируя видео с полной повествовательной логикой.',

      imageToVideoTitle: 'Интеллектуальный движок изображение-в-видео',
      imageToVideoDescription:
          'Оживите статические изображения. Просто загрузите референсное изображение, и WeryAI Video 1.0 точно определит структуру объекта и добавит физически корректные динамические эффекты. Будь то естественное моргание и улыбка неподвижного человека или течение воды на пейзаже — достигается естественная анимация при сохранении оригинального качества изображения.',

      fastRenderTitle: 'Технология сверхбыстрого рендеринга',
      fastRenderDescription:
          'Оптимизировано для высокочастотного создания. Благодаря уникальной оптимизации архитектуры модели WeryAI скорость генерации Video 1.0 значительно превышает средние показатели по отрасли. Вы можете получить 5-10 секунд HD-видеоклипов за очень короткое время (обычно 40-60 секунд), делая творческую итерацию без ожидания.',

      physicsTitle: 'Симуляция движения на физическом уровне',
      physicsDescription:
          'Откажитесь от искажений, вызванных "ИИ-галлюцинациями". Наша модель обучена на массивных данных физической динамики с глубоким пониманием жидкостей, тканей, гравитации и других физических правил. В сгенерированных видео движения персонажей плавные и естественные, а столкновения объектов следуют логике реального мира.',

      howToUseTitle: 'Как использовать WeryAI Video 1.0',
      howToUseSubtitle: 'Три простых шага для начала',
      step1Title: 'Выберите модель',
      step1Description: 'Выберите модель <span class="highlight-text">WeryAI Video 1.0</span> в инструменте ИИ-видео',
      step2Title: 'Введите промпт',
      step2Description: 'Опишите свою творческую историю в текстовом поле или загрузите изображение для активации режима "Изображение в видео".',
      step3Title: 'Сгенерируйте видео',
      step3Description: 'Выберите целевое соотношение сторон (16:9 кинематографическое или 9:16 портретное) и длительность видео, нажмите "Генерировать" и просмотрите и скачайте свой видеошедевр за считанные мгновения.',

      exploreModelsTitle: 'Исследуйте другие модели',
      runwayTitle: 'Генератор видео Runway Gen-4.5',
      klingTitle: 'Генератор видео Kling 2.6',
      veo31Title: 'Генератор видео Google Veo 3.1',
      soraTitle: 'Генератор видео Sora 2',

      faqTitle: 'Часто задаваемые вопросы',
      faq1Question: 'Что такое WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 — это флагманская модель генерации видео с ИИ, независимо запущенная WeryAI. Она интегрирует нашу новейшую технологию визуальной генерации, разработанную для предоставления пользователям самой быстрой скорости и сильнейших повествовательных возможностей для создания видео.',
      faq2Question: 'Что может WeryAI Video 1.0?',
      faq2Answer:
          'Он может преобразовать ваши текстовые сценарии или статические изображения в живые видеоклипы. Отлично справляется с кинематографическим языком камеры (движениями камеры и переходами) и сложной физической динамикой, идеально подходит для создания коротких видео, рекламы и анимированных обоев.',
      faq3Question: 'Это бесплатно на WeryAI?',
      faq3Answer:
          'Да, как преимущество платформы, все зарегистрированные пользователи получают бесплатные кредиты ежедневно для опыта работы с WeryAI Video 1.0. Переход на Pro-членство дает вам более быстрые каналы генерации и больше ежедневной квоты.',
      faq4Question: 'Какое качество и длительность сгенерированных видео?',
      faq4Answer:
          'WeryAI Video 1.0 специализируется на создании коротких видео продолжительностью 5 и 10 секунд в HD-качестве. Мы специально оптимизировали структуру изображения для кристально чистого и плавного воспроизведения на мобильных устройствах и в веб-браузерах.',
      faq5Question: 'Чем он отличается от других моделей на платформе (таких как Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 — наша нативная модель, что означает самую быструю скорость отклика и высочайшую стабильность на платформе WeryAI. По сравнению с другими сторонними моделями, она специально оптимизирована для "мультикадровой непрерывности" и "скорости генерации", что делает её более подходящей для создателей, ориентированных на эффективность.',

      ctaTitle: 'Готовы начать создавать?',
      ctaDescription: 'Испытайте WeryAI Video 1.0 сейчас и превратите свою креативность в потрясающие видео',
      ctaButton: 'Начать создание',
      ctaDisclaimer: 'Кредитная карта не требуется · Бесплатная пробная версия для новых пользователей',
  },
  pt: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'Gerador de vídeos IA WeryAI Video 1.0 - Ferramenta principal de criação de vídeos IA | WeryAI',
      pageDescription:
          'WeryAI Video 1.0 é o modelo principal de geração de vídeo IA lançado pela WeryAI, com narrativa multi-tomada, imagem para vídeo inteligente, renderização ultrarrápida e simulação de movimento em nível físico. Experimente gratuitamente no WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, gerador de vídeo IA, criação de vídeo IA, vídeo inteligência artificial, ferramenta de geração de vídeo, vídeo IA grátis, WeryAI, narrativa multi-tomada, imagem para vídeo',

      generatorTitle: 'Gerador de vídeos WeryAI Video 1.0',
      generatorDescription:
          'WeryAI Video 1.0 é o modelo principal de geração de vídeo IA lançado pela WeryAI. Representa nossa busca pelo equilíbrio perfeito entre "velocidade" e "arte", com motores avançados de compreensão semântica e simulação física, pioneiro na capacidade de <span class="text-text-active">"narrativa multi-tomada nativa"</span>. <span class="text-text-active">Experimente gratuitamente no gerador de vídeo WeryAI</span>!',

      tabImageToVideo: 'Imagem para vídeo',
      tabTextToVideo: 'Texto para vídeo',

      coreFeaturesTitle: 'Recursos principais do WeryAI Video 1.0',
      coreFeaturesSubtitle: 'Explore os recursos principais do WeryAI Video 1.0 e comece sua jornada de criação de vídeo de próxima geração',

      multiShotTitle: 'Sistema de narrativa multi-tomada',
      multiShotDescription:
          'O avanço central do WeryAI Video 1.0. Quebra as limitações da geração de tomada única tradicional, compreendendo e executando instruções de câmera complexas (como push, pull, pan, tilt e transições). O modelo garante alta consistência de características dos personagens e iluminação da cena durante as transições de tomadas, gerando diretamente vídeos com lógica narrativa completa.',

      imageToVideoTitle: 'Motor inteligente de imagem para vídeo',
      imageToVideoDescription:
          'Dê vida às imagens estáticas. Basta carregar uma imagem de referência e o WeryAI Video 1.0 pode identificar com precisão a estrutura do assunto e adicionar efeitos dinâmicos em conformidade com a física. Seja fazer uma pessoa parada piscar e sorrir naturalmente, ou fazer a água fluir em uma paisagem, alcança animação natural preservando a qualidade original da imagem.',

      fastRenderTitle: 'Tecnologia de renderização ultrarrápida',
      fastRenderDescription:
          'Otimizado para criação de alta frequência. Graças à otimização única da arquitetura do modelo WeryAI, a velocidade de geração do Video 1.0 supera em muito as médias da indústria. Você pode obter clipes de vídeo HD de 5-10 segundos em muito pouco tempo (tipicamente 40-60 segundos), tornando a iteração criativa sem espera.',

      physicsTitle: 'Simulação de movimento em nível físico',
      physicsDescription:
          'Rejeite a distorção causada por "alucinações de IA". Nosso modelo é treinado com dados massivos de dinâmica física com compreensão profunda de fluidos, tecidos, gravidade e outras regras físicas. Nos vídeos gerados, os movimentos dos personagens são suaves e naturais, e as colisões de objetos seguem a lógica do mundo real.',

      howToUseTitle: 'Como usar o WeryAI Video 1.0',
      howToUseSubtitle: 'Três passos simples para começar',
      step1Title: 'Selecionar modelo',
      step1Description: 'Selecione o modelo <span class="highlight-text">WeryAI Video 1.0</span> na ferramenta de vídeo IA',
      step2Title: 'Inserir prompt',
      step2Description: 'Descreva sua história criativa na caixa de texto, ou carregue uma imagem para habilitar o modo "Imagem para vídeo".',
      step3Title: 'Gerar vídeo',
      step3Description: 'Selecione sua proporção de aspecto alvo (16:9 cinematográfico ou 9:16 retrato) e duração do vídeo, clique em "Gerar" e visualize e baixe sua obra-prima de vídeo em instantes.',

      exploreModelsTitle: 'Explorar outros modelos',
      runwayTitle: 'Gerador de vídeo IA Runway Gen-4.5',
      klingTitle: 'Gerador de vídeo IA Kling 2.6',
      veo31Title: 'Gerador de vídeo IA Google Veo 3.1',
      soraTitle: 'Gerador de vídeo IA Sora 2',

      faqTitle: 'Perguntas frequentes',
      faq1Question: 'O que é o WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 é o modelo principal de geração de vídeo IA lançado independentemente pela WeryAI. Integra nossa mais recente tecnologia de geração visual, projetada para fornecer aos usuários a velocidade mais rápida e as capacidades narrativas mais fortes para criação de vídeo.',
      faq2Question: 'O que o WeryAI Video 1.0 pode fazer?',
      faq2Answer:
          'Pode transformar seus scripts de texto ou imagens estáticas em clipes de vídeo vívidos. Destaca-se no tratamento de linguagem de câmera cinematográfica (como movimentos de câmera e transições) e dinâmica física complexa, perfeito para criar vídeos curtos, anúncios e papéis de parede animados.',
      faq3Question: 'É grátis usar no WeryAI?',
      faq3Answer:
          'Sim, como benefício da plataforma, todos os usuários registrados recebem créditos gratuitos diários para experimentar o WeryAI Video 1.0. Atualizar para a assinatura Pro dá canais de geração mais rápidos e mais cota diária.',
      faq4Question: 'Qual é a qualidade e duração dos vídeos gerados?',
      faq4Answer:
          'WeryAI Video 1.0 foca na geração de vídeos curtos de 5s e 10s otimizados em HD. Otimizamos especialmente a estrutura visual para uma reprodução extremamente nítida e fluida em dispositivos móveis e navegadores web.',
      faq5Question: 'Como é diferente de outros modelos na plataforma (como Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 é nosso modelo nativo, o que significa que tem a velocidade de resposta mais rápida e maior estabilidade na plataforma WeryAI. Comparado com outros modelos de terceiros, é especialmente otimizado para "continuidade multi-tomada" e "velocidade de geração", sendo mais adequado para criadores focados em eficiência.',

      ctaTitle: 'Pronto para começar a criar?',
      ctaDescription: 'Experimente o WeryAI Video 1.0 agora e transforme sua criatividade em vídeos incríveis',
      ctaButton: 'Começar a criar',
      ctaDisclaimer: 'Não é necessário cartão de crédito · Teste grátis para novos usuários',
  },
  it: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'Generatore video IA WeryAI Video 1.0 - Strumento di punta per la creazione video IA | WeryAI',
      pageDescription:
          'WeryAI Video 1.0 è il modello di punta per la generazione video IA lanciato da WeryAI, con narrazione multi-shot, immagine-a-video intelligente, rendering ultra-rapido e simulazione del movimento a livello fisico. Provalo gratis su WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, generatore video IA, creazione video IA, video intelligenza artificiale, strumento generazione video, video IA gratis, WeryAI, narrazione multi-shot, immagine a video',

      generatorTitle: 'Generatore video WeryAI Video 1.0',
      generatorDescription:
          'WeryAI Video 1.0 è il modello di punta per la generazione video IA lanciato da WeryAI. Rappresenta la nostra ricerca dell\'equilibrio perfetto tra "velocità" e "arte", con motori avanzati di comprensione semantica e simulazione fisica, pioniere nella capacità di <span class="text-text-active">"narrazione multi-shot nativa"</span>. <span class="text-text-active">Provalo gratis nel generatore video WeryAI</span>!',

      tabImageToVideo: 'Immagine a video',
      tabTextToVideo: 'Testo a video',

      coreFeaturesTitle: 'Funzionalità principali di WeryAI Video 1.0',
      coreFeaturesSubtitle: 'Esplora le funzionalità principali di WeryAI Video 1.0 e inizia il tuo viaggio nella creazione video di nuova generazione',

      multiShotTitle: 'Sistema di narrazione multi-shot',
      multiShotDescription:
          'La svolta centrale di WeryAI Video 1.0. Supera i limiti della generazione tradizionale a singolo shot, comprendendo ed eseguendo istruzioni di camera complesse (come push, pull, pan, tilt e transizioni). Il modello garantisce alta coerenza delle caratteristiche dei personaggi e dell\'illuminazione della scena durante le transizioni di shot, generando direttamente video con logica narrativa completa.',

      imageToVideoTitle: 'Motore intelligente immagine-a-video',
      imageToVideoDescription:
          'Dai vita alle immagini statiche. Carica semplicemente un\'immagine di riferimento e WeryAI Video 1.0 può identificare con precisione la struttura del soggetto e aggiungere effetti dinamici conformi alla fisica. Che si tratti di far battere le palpebre e sorridere naturalmente una persona ferma, o far scorrere l\'acqua in un paesaggio, ottiene un\'animazione naturale preservando la qualità originale dell\'immagine.',

      fastRenderTitle: 'Tecnologia di rendering ultra-rapido',
      fastRenderDescription:
          'Ottimizzato per la creazione ad alta frequenza. Grazie all\'ottimizzazione unica dell\'architettura del modello WeryAI, la velocità di generazione di Video 1.0 supera di gran lunga le medie del settore. Puoi ottenere clip video HD da 5-10 secondi in pochissimo tempo (tipicamente 40-60 secondi), rendendo l\'iterazione creativa senza attese.',

      physicsTitle: 'Simulazione del movimento a livello fisico',
      physicsDescription:
          'Rifiuta la distorsione causata dalle "allucinazioni IA". Il nostro modello è addestrato su enormi dati di dinamica fisica con profonda comprensione di fluidi, tessuti, gravità e altre regole fisiche. Nei video generati, i movimenti dei personaggi sono fluidi e naturali, e le collisioni degli oggetti seguono la logica del mondo reale.',

      howToUseTitle: 'Come usare WeryAI Video 1.0',
      howToUseSubtitle: 'Tre semplici passaggi per iniziare',
      step1Title: 'Seleziona il modello',
      step1Description: 'Seleziona il modello <span class="highlight-text">WeryAI Video 1.0</span> nello strumento video IA',
      step2Title: 'Inserisci il prompt',
      step2Description: 'Descrivi la tua storia creativa nella casella di testo, o carica un\'immagine per abilitare la modalità "Immagine a video".',
      step3Title: 'Genera il video',
      step3Description: 'Seleziona il rapporto d\'aspetto target (16:9 cinematografico o 9:16 verticale) e la durata del video, clicca su "Genera" e visualizza e scarica il tuo capolavoro video in pochi istanti.',

      exploreModelsTitle: 'Esplora altri modelli',
      runwayTitle: 'Generatore video IA Runway Gen-4.5',
      klingTitle: 'Generatore video IA Kling 2.6',
      veo31Title: 'Generatore video IA Google Veo 3.1',
      soraTitle: 'Generatore video IA Sora 2',

      faqTitle: 'Domande frequenti',
      faq1Question: 'Cos\'è WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 è il modello di punta per la generazione video IA lanciato indipendentemente da WeryAI. Integra la nostra più recente tecnologia di generazione visiva, progettata per fornire agli utenti la velocità più rapida e le capacità narrative più forti per la creazione video.',
      faq2Question: 'Cosa può fare WeryAI Video 1.0?',
      faq2Answer:
          'Può trasformare i tuoi script di testo o immagini statiche in vivaci clip video. Eccelle nella gestione del linguaggio cinematografico della camera (come movimenti di camera e transizioni) e dinamiche fisiche complesse, perfetto per creare video brevi, pubblicità e sfondi animati.',
      faq3Question: 'È gratis usarlo su WeryAI?',
      faq3Answer:
          'Sì, come vantaggio della piattaforma, tutti gli utenti registrati ricevono crediti gratuiti giornalieri per provare WeryAI Video 1.0. Passare all\'abbonamento Pro ti dà canali di generazione più veloci e più quota giornaliera.',
      faq4Question: 'Qual è la qualità e la durata dei video generati?',
      faq4Answer:
          'WeryAI Video 1.0 si concentra sulla generazione di video brevi di 5s e 10s ottimizzati in HD. Abbiamo ottimizzato appositamente la struttura visiva per una riproduzione cristallina e fluida su dispositivi mobili e browser web.',
      faq5Question: 'In cosa è diverso dagli altri modelli sulla piattaforma (come Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 è il nostro modello nativo, il che significa che ha la velocità di risposta più rapida e la massima stabilità sulla piattaforma WeryAI. Rispetto ad altri modelli di terze parti, è specificamente ottimizzato per "continuità multi-shot" e "velocità di generazione", rendendolo più adatto ai creatori focalizzati sull\'efficienza.',

      ctaTitle: 'Pronto a iniziare a creare?',
      ctaDescription: 'Prova WeryAI Video 1.0 ora e trasforma la tua creatività in video straordinari',
      ctaButton: 'Inizia a creare',
      ctaDisclaimer: 'Nessuna carta di credito richiesta · Prova gratuita per i nuovi utenti',
  },
  ar: {
    modelName: 'WeryAI Video 1.0',
    pageTitle: 'مولد فيديو WeryAI Video 1.0 بالذكاء الاصطناعي - أداة رائدة لإنشاء الفيديو بالذكاء الاصطناعي | WeryAI',
    pageDescription:
        'WeryAI Video 1.0 هو النموذج الرائد لتوليد الفيديو بالذكاء الاصطناعي من WeryAI، مع سرد متعدد اللقطات، تحويل صورة إلى فيديو ذكي، عرض فائق السرعة، ومحاكاة حركة على مستوى الفيزياء. جربه مجانًا على WeryAI.',
    pageKeywords:
        'WeryAI Video 1.0, مولد فيديو ذكاء اصطناعي, إنشاء فيديو بالذكاء الاصطناعي, فيديو ذكاء اصطناعي, أداة توليد الفيديو, فيديو ذكاء اصطناعي مجاني, WeryAI, سرد متعدد اللقطات, صورة إلى فيديو',

    generatorTitle: 'مولد فيديو WeryAI Video 1.0',
    generatorDescription:
        'WeryAI Video 1.0 هو النموذج الرائد لتوليد الفيديو بالذكاء الاصطناعي من WeryAI. يمثل سعينا نحو التوازن المثالي بين "السرعة" و"الفن"، مع محركات متقدمة للفهم الدلالي ومحاكاة الفيزياء، رائدًا في قدرة <span class="text-text-active">"السرد الأصلي متعدد اللقطات"</span>. <span class="text-text-active">جربه مجانًا في مولد فيديو WeryAI</span>!',

    tabImageToVideo: 'صورة إلى فيديو',
    tabTextToVideo: 'نص إلى فيديو',

    coreFeaturesTitle: 'الميزات الأساسية لـ WeryAI Video 1.0',
    coreFeaturesSubtitle: 'استكشف الميزات الأساسية لـ WeryAI Video 1.0 وابدأ رحلة إنشاء الفيديو من الجيل التالي',

    multiShotTitle: 'نظام السرد متعدد اللقطات',
    multiShotDescription:
        'الاختراق الجوهري لـ WeryAI Video 1.0. يكسر قيود توليد اللقطة الواحدة التقليدية، ويفهم وينفذ تعليمات الكاميرا المعقدة (مثل الدفع والسحب والتحريك الأفقي والإمالة والانتقالات). يضمن النموذج تناسقًا عاليًا لخصائص الشخصيات وإضاءة المشهد أثناء انتقالات اللقطات، وينتج مباشرة مقاطع فيديو بمنطق سردي كامل.',

    imageToVideoTitle: 'محرك صورة إلى فيديو ذكي',
    imageToVideoDescription:
        'أضف الحياة للصور الثابتة. ما عليك سوى تحميل صورة مرجعية، ويمكن لـ WeryAI Video 1.0 تحديد بنية الموضوع بدقة وإضافة تأثيرات ديناميكية متوافقة مع الفيزياء. سواء كان جعل شخص ثابت يرمش ويبتسم بشكل طبيعي، أو جعل الماء يتدفق في لوحة منظر طبيعي، فإنه يحقق الرسوم المتحركة الطبيعية مع الحفاظ على جودة الصورة الأصلية.',

    fastRenderTitle: 'تقنية العرض فائقة السرعة',
    fastRenderDescription:
        'محسّن للإبداع عالي التردد. بفضل تحسين معمارية النموذج الفريدة من WeryAI، تتجاوز سرعة توليد Video 1.0 متوسطات الصناعة بكثير. يمكنك الحصول على مقاطع فيديو HD من 5-10 ثوانٍ في وقت قصير جدًا (عادةً 40-60 ثانية)، مما يجعل التكرار الإبداعي بدون انتظار.',

    physicsTitle: 'محاكاة الحركة على مستوى الفيزياء',
    physicsDescription:
        'ارفض التشوه الناجم عن "هلوسات الذكاء الاصطناعي". تم تدريب نموذجنا على بيانات ضخمة لديناميكيات الفيزياء مع فهم عميق للسوائل والأقمشة والجاذبية وقواعد الفيزياء الأخرى. في مقاطع الفيديو المُنشأة، حركات الشخصيات سلسة وطبيعية، وتصادمات الأجسام تتبع منطق العالم الحقيقي.',

    howToUseTitle: 'كيفية استخدام WeryAI Video 1.0',
    howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء',
    step1Title: 'اختر النموذج',
    step1Description: 'اختر نموذج <span class="highlight-text">WeryAI Video 1.0</span> في أداة الفيديو بالذكاء الاصطناعي',
    step2Title: 'أدخل الموجه',
    step2Description: 'صف قصتك الإبداعية في مربع النص، أو قم بتحميل صورة لتفعيل وضع "صورة إلى فيديو".',
    step3Title: 'أنشئ الفيديو',
    step3Description: 'اختر نسبة العرض إلى الارتفاع المستهدفة (16:9 سينمائي أو 9:16 عمودي) ومدة الفيديو، انقر على "إنشاء" وشاهد وقم بتنزيل تحفتك الفنية في لحظات.',

    exploreModelsTitle: 'استكشف نماذج أخرى',
    runwayTitle: 'مولد فيديو Runway Gen-4.5 بالذكاء الاصطناعي',
    klingTitle: 'مولد فيديو Kling 2.6 بالذكاء الاصطناعي',
    veo31Title: 'مولد فيديو Google Veo 3.1 بالذكاء الاصطناعي',
    soraTitle: 'مولد فيديو Sora 2 بالذكاء الاصطناعي',

    faqTitle: 'الأسئلة الشائعة',
    faq1Question: 'ما هو WeryAI Video 1.0؟',
    faq1Answer:
        'WeryAI Video 1.0 هو النموذج الرائد لتوليد الفيديو بالذكاء الاصطناعي الذي أطلقته WeryAI بشكل مستقل. يدمج أحدث تقنيات التوليد البصري لدينا، مصممًا لتزويد المستخدمين بأسرع سرعة وأقوى قدرات سردية لإنشاء الفيديو.',
    faq2Question: 'ماذا يمكن أن يفعل WeryAI Video 1.0؟',
    faq2Answer:
        'يمكنه تحويل نصوصك أو صورك الثابتة إلى مقاطع فيديو حية. يتفوق في التعامل مع لغة الكاميرا السينمائية (مثل حركات الكاميرا والانتقالات) والديناميكيات الفيزيائية المعقدة، مثالي لإنشاء الفيديوهات القصيرة والإعلانات وخلفيات الشاشة المتحركة.',
    faq3Question: 'هل هو مجاني للاستخدام على WeryAI؟',
    faq3Answer:
        'نعم، كميزة من مزايا المنصة، يحصل جميع المستخدمين المسجلين على رصيد مجاني يوميًا لتجربة WeryAI Video 1.0. الترقية إلى عضوية Pro تمنحك قنوات توليد أسرع وحصة يومية أكبر.',
    faq4Question: 'ما هي جودة ومدة مقاطع الفيديو المُنشأة؟',
    faq4Answer:
        'يركز WeryAI Video 1.0 على إنشاء مقاطع فيديو قصيرة مُحسّنة بدقة عالية (HD) بمدة 5 ثوانٍ و10 ثوانٍ. لقد قمنا بتحسين بنية الصورة بشكل خاص لضمان تشغيل واضح للغاية وسلس على الأجهزة المحمولة ومتصفحات الويب.',
    faq5Question: 'كيف يختلف عن النماذج الأخرى على المنصة (مثل Kling، Luma)؟',
    faq5Answer:
        'WeryAI Video 1.0 هو نموذجنا الأصلي، مما يعني أن لديه أسرع سرعة استجابة وأعلى استقرار على منصة WeryAI. مقارنة بنماذج الطرف الثالث الأخرى، تم تحسينه خصيصًا لـ "استمرارية اللقطات المتعددة" و"سرعة التوليد"، مما يجعله أكثر ملاءمة للمبدعين الذين يركزون على الكفاءة.',

    ctaTitle: 'هل أنت مستعد للبدء في الإبداع؟',
    ctaDescription: 'جرب WeryAI Video 1.0 الآن وحوّل إبداعك إلى فيديوهات مذهلة',
    ctaButton: 'ابدأ الإبداع',
    ctaDisclaimer: 'لا حاجة إلى بطاقة ائتمان · تجربة مجانية للمستخدمين الجدد',
  },
  tw: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'WeryAI Video 1.0 AI 影片生成器 - WeryAI 旗艦級 AI 影片創作工具',
      pageDescription:
          'WeryAI Video 1.0 是 WeryAI 平台推出的首款旗艦級 AI 影片生成模型，具備多鏡頭敘事、智慧圖生影片、極速渲染、物理級動作模擬等核心功能。在 WeryAI 平台免費試用。',
      pageKeywords:
          'WeryAI Video 1.0, AI 影片產生器, AI 影片創作, 人工智慧影片, 影片生成工具, 免費 AI 影片, WeryAI, 多鏡頭敘事, 圖生影片',
      generatorTitle: 'WeryAI Video 1.0 影片生成器',
      generatorDescription: 'WeryAI Video 1.0 是 WeryAI 平台重磅推出的首款旗艦級 AI 影片生成模型。它代表了我們對「速度」與「藝術性」完美平衡的極致追求，內建先進的語義理解演算法與物理模擬引擎，首創<span class="text-text-active">「原生多鏡頭敘事」</span>能力。<span class="text-text-active">在 WeryAI 影片生成器上免費試用</span>！',
      tabImageToVideo: '圖生影片',
      tabTextToVideo: '文生影片',
      coreFeaturesTitle: 'WeryAI Video 1.0 核心功能',
      coreFeaturesSubtitle: '探索 WeryAI Video 1.0 的核心功能，開啟下一代影片創作之旅',
      multiShotTitle: '多鏡頭敘事系統',
      multiShotDescription: 'WeryAI Video 1.0 的核心突破。它打破了傳統模型單鏡頭生成的限制，能夠理解並執行複雜的運鏡指令。模型能確保在鏡頭切換過程中，角色特徵、場景光影保持高度統一，直接生成一段具有完整敘事邏輯的影片。',
      imageToVideoTitle: '智能圖生影片引擎',
      imageToVideoDescription: '賦予靜態圖像以生命。只需上傳一張參考圖，WeryAI Video 1.0 即可精準識別主體結構，賦予其符合物理規律的動態效果。',
      fastRenderTitle: '極速渲染技術',
      fastRenderDescription: '專為高頻創作優化。得益於 WeryAI 獨特的模型架構優化，Video 1.0 的生成速度遠超行業平均水準。您可以在極短時間內（通常40-60秒）獲得 5-10 秒的高清影片片段。',
      physicsTitle: '物理級動作模擬',
      physicsDescription: '拒絕「AI幻覺」帶來的崩壞感。我們的模型經過海量物理動態數據訓練，對流體、布料、重力等物理規則有深刻理解。',
      howToUseTitle: '如何使用 WeryAI Video 1.0',
      howToUseSubtitle: '簡單三步，開始創作',
      step1Title: '選擇模型',
      step1Description: '在 AI 影片工具中選擇 <span class="highlight-text">WeryAI Video 1.0</span> 模型',
      step2Title: '輸入提示詞',
      step2Description: '在文字框中描述您的創意故事，或上傳圖片開啟「圖生影片」模式。',
      step3Title: '生成影片',
      step3Description: '選擇您的目標畫幅及影片時長，點擊「生成」按鈕，稍等片刻即可預覽並下載您的影片大片。',
      exploreModelsTitle: '探索其他模型',
      runwayTitle: 'Runway Gen-4.5 AI 影片生成器',
      klingTitle: 'Kling 2.6 AI 影片生成器',
      veo31Title: 'Google Veo 3.1 AI 影片生成器',
      soraTitle: 'Sora 2 AI 影片生成器',
      faqTitle: '常見問題',
      faq1Question: 'WeryAI Video 1.0 是什麼？',
      faq1Answer: 'WeryAI Video 1.0 是 WeryAI 平台自主推出的旗艦級 AI 影片生成模型。它整合了我們最新的視覺生成技術，旨在為用戶提供速度最快、敘事能力最強的影片創作體驗。',
      faq2Question: 'WeryAI Video 1.0 主要能做什麼？',
      faq2Answer: '它能將您的文字腳本或靜態圖片轉化為生動的影片片段。它特別擅長處理電影級的鏡頭語言和複雜的物理動態，是製作短影片、廣告片和動態桌布的利器。',
      faq3Question: '在 WeryAI 上使用是免費的嗎？',
      faq3Answer: '是的，作為平台福利，所有註冊用戶每天都可獲得免費積分來體驗 WeryAI Video 1.0。升級為 Pro 會員後，您將獲得更快的生成通道和更多的每日額度。',
      faq4Question: '生成影片的品質和時長如何？',
      faq4Answer: 'WeryAI Video 1.0 專注於生成高清（HD Optimized）的 5s、10s 的短影片。我們特別優化了畫面結構，使其在行動端和網頁端播放時極其清晰流暢。',
      faq5Question: '它和平台上的其他模型（如可靈、Luma）有什麼區別？',
      faq5Answer: 'WeryAI Video 1.0 是我們的原生模型，這意味著它在 WeryAI 平台上的響應速度最快、穩定性最高。相比其他第三方模型，它在「多鏡頭連續性」和「生成速度」上進行了專門優化。',
      ctaTitle: '準備開始創作了嗎？',
      ctaDescription: '立即體驗 WeryAI Video 1.0，將您的創意轉化為精彩影片',
      ctaButton: '開始創作',
      ctaDisclaimer: '無需信用卡 · 新使用者免費體驗',
  },
  pl: {
      modelName: 'WeryAI Video 1.0',
      pageTitle: 'Generator wideo AI WeryAI Video 1.0 - Flagowe narzędzie do tworzenia wideo AI | WeryAI',
      pageDescription: 'WeryAI Video 1.0 to flagowy model generowania wideo AI uruchomiony przez WeryAI, z narracją wieloujęciową, inteligentnym obrazem do wideo, ultraszybkim renderowaniem i symulacją ruchu na poziomie fizyki. Wypróbuj za darmo na WeryAI.',
      pageKeywords: 'WeryAI Video 1.0, generator wideo AI, tworzenie wideo AI, wideo sztuczna inteligencja, narzędzie do generowania wideo, darmowe wideo AI, WeryAI, narracja wieloujęciowa, obraz do wideo',
      generatorTitle: 'Generator wideo WeryAI Video 1.0',
      generatorDescription: 'WeryAI Video 1.0 to flagowy model generowania wideo AI uruchomiony przez WeryAI. Reprezentuje nasze dążenie do idealnej równowagi między "szybkością" a "sztuką", z zaawansowanymi silnikami rozumienia semantycznego i symulacji fizyki, pionierem w zdolności <span class="text-text-active">"natywnej narracji wieloujęciowej"</span>. <span class="text-text-active">Wypróbuj za darmo w generatorze wideo WeryAI</span>!',
      tabImageToVideo: 'Obraz do wideo',
      tabTextToVideo: 'Tekst do wideo',
      coreFeaturesTitle: 'Główne funkcje WeryAI Video 1.0',
      coreFeaturesSubtitle: 'Odkryj główne funkcje WeryAI Video 1.0 i rozpocznij podróż tworzenia wideo nowej generacji',
      multiShotTitle: 'System narracji wieloujęciowej',
      multiShotDescription:
          'Kluczowy przełom WeryAI Video 1.0. Przełamuje ograniczenia tradycyjnego generowania pojedynczego ujęcia, rozumiejąc i wykonując złożone instrukcje kamery (takie jak najazd, odjazd, panorama, pochylenie i przejścia). Model zapewnia wysoką spójność cech postaci i oświetlenia sceny podczas przejść między ujęciami, bezpośrednio generując filmy z pełną logiką narracyjną.',
      imageToVideoTitle: 'Inteligentny silnik obraz-do-wideo',
      imageToVideoDescription:
          'Ożyw statyczne obrazy. Wystarczy przesłać obraz referencyjny, a WeryAI Video 1.0 może dokładnie zidentyfikować strukturę obiektu i dodać efekty dynamiczne zgodne z fizyką. Niezależnie od tego, czy chodzi o naturalne mruganie i uśmiechanie się nieruchomej osoby, czy o przepływ wody w krajobrazie, model osiąga naturalną animację przy zachowaniu oryginalnej jakości obrazu.',
      fastRenderTitle: 'Technologia ultraszybkiego renderowania',
      fastRenderDescription:
          'Zoptymalizowany dla tworzenia o wysokiej częstotliwości. Dzięki unikalnej optymalizacji architektury modelu WeryAI, szybkość generowania Video 1.0 znacznie przewyższa średnie branżowe. Możesz uzyskać 5-10 sekundowe klipy wideo HD w bardzo krótkim czasie (zazwyczaj 40-60 sekund), dzięki czemu iteracja kreatywna nie wymaga czekania.',
      physicsTitle: 'Symulacja ruchu na poziomie fizyki',
      physicsDescription:
          'Odrzuć zniekształcenia spowodowane „halucynacjami AI”. Nasz model jest trenowany na masowych danych dynamiki fizyki z głębokim zrozumieniem płynów, tkanin, grawitacji i innych reguł fizycznych. W generowanych filmach ruchy postaci są płynne i naturalne, a kolizje obiektów następują zgodnie z logiką świata rzeczywistego.',
      howToUseTitle: 'Jak używać WeryAI Video 1.0',
      howToUseSubtitle: 'Trzy proste kroki do rozpoczęcia',
      step1Title: 'Wybierz model',
      step1Description: 'Wybierz model <span class="highlight-text">WeryAI Video 1.0</span> w narzędziu wideo AI',
      step2Title: 'Wprowadź prompt',
      step2Description: 'Opisz swoją kreatywną historię w polu tekstowym lub prześlij obraz, aby włączyć tryb "Obraz do wideo".',
      step3Title: 'Wygeneruj wideo',
      step3Description: 'Wybierz docelowy współczynnik proporcji i czas trwania wideo, kliknij "Generuj" i obejrzyj oraz pobierz swoje arcydzieło wideo w kilka chwil.',
      exploreModelsTitle: 'Odkryj inne modele',
      runwayTitle: 'Generator wideo AI Runway Gen-4.5',
      klingTitle: 'Generator wideo AI Kling 2.6',
      veo31Title: 'Generator wideo AI Google Veo 3.1',
      soraTitle: 'Generator wideo AI Sora 2',
      faqTitle: 'Najczęściej zadawane pytania',
      faq1Question: 'Czym jest WeryAI Video 1.0?',
      faq1Answer: 'WeryAI Video 1.0 to flagowy model generowania wideo AI niezależnie uruchomiony przez WeryAI. Integruje naszą najnowszą technologię generowania wizualnego, zaprojektowaną, aby zapewnić użytkownikom najszybszą prędkość i najsilniejsze możliwości narracyjne do tworzenia wideo.',
      faq2Question: 'Co może WeryAI Video 1.0?',
      faq2Answer: 'Może przekształcić twoje skrypty tekstowe lub statyczne obrazy w żywe klipy wideo. Wyróżnia się w obsłudze kinowego języka kamery i złożonej dynamiki fizycznej, idealny do tworzenia krótkich filmów, reklam i animowanych tapet.',
      faq3Question: 'Czy jest darmowy na WeryAI?',
      faq3Answer: 'Tak, jako korzyść platformy, wszyscy zarejestrowani użytkownicy otrzymują codziennie darmowe kredyty do doświadczania WeryAI Video 1.0. Przejście na członkostwo Pro daje szybsze kanały generowania i większy dzienny limit.',
      faq4Question: 'Jaka jest jakość i czas trwania generowanych filmów?',
      faq4Answer: 'WeryAI Video 1.0 koncentruje się na generowaniu krótkich filmów zoptymalizowanych w HD o długości 5s i 10s. Specjalnie zoptymalizowaliśmy strukturę wizualną dla krystalicznie czystego i płynnego odtwarzania na urządzeniach mobilnych i przeglądarkach internetowych.',
      faq5Question: 'Czym różni się od innych modeli na platformie (jak Kling, Luma)?',
      faq5Answer: 'WeryAI Video 1.0 to nasz natywny model, co oznacza, że ma najszybszą szybkość odpowiedzi i najwyższą stabilność na platformie WeryAI. W porównaniu z innymi modelami firm trzecich, jest specjalnie zoptymalizowany pod kątem "ciągłości wieloujęciowej" i "szybkości generowania".',
      ctaTitle: 'Gotowy do rozpoczęcia tworzenia?',
      ctaDescription: 'Doświadcz WeryAI Video 1.0 teraz i przekształć swoją kreatywność w niesamowite filmy',
      ctaButton: 'Zacznij tworzyć',
      ctaDisclaimer: 'Karta kredytowa nie jest wymagana · Darmowy okres próbny dla nowych użytkowników',
  },
    th: {
      // Model name
      modelName: 'WeryAI Video 1.0',

      // Page title and description
      pageTitle:
          'WeryAI Video 1.0 เครื่องมือสร้างวิดีโอ AI - เครื่องมือสร้างวิดีโอ AI เรือธงของ WeryAI',
      pageDescription:
          'WeryAI Video 1.0 คือโมเดลสร้างวิดีโอ AI เรือธงของ WeryAI โดดเด่นด้วยการเล่าเรื่องหลายช็อต แปลงภาพเป็นวิดีโออัจฉริยะ การเรนเดอร์ความเร็วสูง และการจำลองการเคลื่อนไหวระดับฟิสิกส์ ลองใช้ฟรีบน WeryAI',
      pageKeywords:
          'WeryAI Video 1.0, เครื่องมือสร้างวิดีโอ AI, การสร้างวิดีโอด้วย AI, วิดีโอปัญญาประดิษฐ์, เครื่องมือสร้างวิดีโอ, วิดีโอ AI ฟรี, WeryAI, เล่าเรื่องหลายช็อต, ภาพเป็นวิดีโอ',

      // Generator section
      generatorTitle: 'เครื่องมือสร้างวิดีโอ WeryAI Video 1.0',
      generatorDescription:
          'WeryAI Video 1.0 คือโมเดลสร้างวิดีโอ AI เรือธงของ WeryAI เป็นผลลัพธ์ของการแสวงหาความสมดุลระหว่าง “ความเร็ว” และ “ศิลป์” ด้วยการทำความเข้าใจเชิงความหมายขั้นสูงและเอนจินจำลองฟิสิกส์ พร้อมความสามารถ <span class="text-text-active">“เล่าเรื่องหลายช็อตแบบเนทีฟ”</span> <span class="text-text-active">ทดลองใช้ฟรีบน WeryAI Video Generator</span>!',

      // Tabs
      tabImageToVideo: 'ภาพเป็นวิดีโอ',
      tabTextToVideo: 'ข้อความเป็นวิดีโอ',

      // Core features section
      coreFeaturesTitle: 'ฟีเจอร์หลักของ WeryAI Video 1.0',
      coreFeaturesSubtitle:
          'สำรวจฟีเจอร์หลักของ WeryAI Video 1.0 และเริ่มเส้นทางสร้างวิดีโอรุ่นถัดไป',

      // Multi-shot narrative system
      multiShotTitle: 'ระบบเล่าเรื่องหลายช็อต',
      multiShotDescription:
          'ก้าวกระโดดสำคัญของ WeryAI Video 1.0 ทำลายข้อจำกัดของการสร้างแบบช็อตเดียว เข้าใจและดำเนินคำสั่งกล้องที่ซับซ้อน (เช่น ดันกล้อง ดึงกล้อง แพน ทิลต์ และทรานซิชัน) โมเดลรักษาความสม่ำเสมอของตัวละครและแสงฉากระหว่างช็อต สร้างวิดีโอที่มีตรรกะการเล่าเรื่องครบถ้วนได้ทันที',

      // Intelligent image-to-video engine
      imageToVideoTitle: 'เอนจินแปลงภาพเป็นวิดีโออัจฉริยะ',
      imageToVideoDescription:
          'ทำให้ภาพนิ่งมีชีวิต เพียงอัปโหลดภาพอ้างอิง WeryAI Video 1.0 จะระบุโครงสร้างวัตถุและเพิ่มเอฟเฟกต์การเคลื่อนไหวตามหลักฟิสิกส์ ไม่ว่าจะเป็นทำให้คนในภาพกะพริบตาและยิ้มอย่างเป็นธรรมชาติ หรือทำให้น้ำไหลในภาพทิวทัศน์ ก็ให้แอนิเมชันที่สมจริงพร้อมคงคุณภาพต้นฉบับ',

      // Ultra-fast rendering technology
      fastRenderTitle: 'เทคโนโลยีเรนเดอร์ความเร็วสูง',
      fastRenderDescription:
          'ออกแบบสำหรับการสร้างสรรค์ถี่ ๆ ด้วยการปรับสถาปัตยกรรมโมเดลเฉพาะของ WeryAI ความเร็วของ Video 1.0 สูงกว่ามาตรฐานอุตสาหกรรมอย่างชัดเจน คุณสามารถได้คลิปวิดีโอ HD 5–10 วินาทีภายในเวลาสั้นมาก (ปกติ 40–60 วินาที) ทำให้การทดลองไอเดียไม่ต้องรอ',

      // Physics-level motion simulation
      physicsTitle: 'การจำลองการเคลื่อนไหวระดับฟิสิกส์',
      physicsDescription:
          'ปฏิเสธความบิดเบี้ยวจาก “AI hallucination” โมเดลถูกฝึกด้วยข้อมูลพลวัตทางฟิสิกส์จำนวนมาก เข้าใจของไหล ผ้า แรงโน้มถ่วง และกฎทางกายภาพอื่น ๆ ในวิดีโอที่สร้าง การเคลื่อนไหวของตัวละครจะลื่นไหลเป็นธรรมชาติ และการชนของวัตถุเป็นไปตามตรรกะโลกจริง',

      // How to use section
      howToUseTitle: 'วิธีใช้ WeryAI Video 1.0',
      howToUseSubtitle: 'เริ่มได้ใน 3 ขั้นตอนง่าย ๆ',
      step1Title: 'เลือกโมเดล',
      step1Description:
          'เลือกโมเดล <span class="highlight-text">WeryAI Video 1.0</span> ในเครื่องมือวิดีโอ AI',
      step2Title: 'ใส่พรอมต์',
      step2Description:
          'บรรยายเรื่องราวของคุณในกล่องข้อความ หรืออัปโหลดภาพเพื่อเปิดโหมด “ภาพเป็นวิดีโอ”',
      step3Title: 'สร้างวิดีโอ',
      step3Description:
          'เลือกระยะภาพ (16:9 แบบภาพยนตร์ หรือ 9:16 แนวตั้ง) และความยาววิดีโอ จากนั้นคลิก “Generate” เพื่อดูตัวอย่างและดาวน์โหลดผลงานในไม่กี่อึดใจ',

      // Explore other models section
      exploreModelsTitle: 'สำรวจโมเดลอื่น ๆ',
      runwayTitle: 'เครื่องมือสร้างวิดีโอ AI Runway Gen-4.5',
      klingTitle: 'เครื่องมือสร้างวิดีโอ AI Kling 2.6',
      veo31Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
      soraTitle: 'เครื่องมือสร้างวิดีโอ AI Sora 2',

      // FAQ section
      faqTitle: 'คำถามที่พบบ่อย',
      faq1Question: 'WeryAI Video 1.0 คืออะไร?',
      faq1Answer:
          'WeryAI Video 1.0 คือโมเดลสร้างวิดีโอ AI เรือธงที่พัฒนาโดย WeryAI เอง ผสานเทคโนโลยีการสร้างภาพรุ่นล่าสุด เพื่อมอบความเร็วสูงสุดและพลังการเล่าเรื่องที่แข็งแกร่งให้กับผู้ใช้',
      faq2Question: 'WeryAI Video 1.0 ทำอะไรได้บ้าง?',
      faq2Answer:
          'สามารถเปลี่ยนสคริปต์ข้อความหรือภาพนิ่งของคุณให้เป็นคลิปวิดีโอที่มีชีวิตชีวา โดดเด่นในการจัดการภาษากล้องแบบภาพยนตร์ (เช่น การเคลื่อนกล้องและทรานซิชัน) และพลวัตทางฟิสิกส์ที่ซับซ้อน เหมาะสำหรับวิดีโอสั้น โฆษณา และวอลเปเปอร์แบบแอนิเมชัน',
      faq3Question: 'ใช้งานบน WeryAI ฟรีหรือไม่?',
      faq3Answer:
          'ฟรี ผู้ใช้ที่ลงทะเบียนจะได้รับเครดิตฟรีรายวันเพื่อทดลอง WeryAI Video 1.0 อัปเกรดเป็น Pro จะได้ช่องทางสร้างที่เร็วขึ้นและโควตารายวันมากขึ้น',
      faq4Question: 'คุณภาพและความยาววิดีโอที่สร้างได้เป็นอย่างไร?',
      faq4Answer:
          'WeryAI Video 1.0 เน้นการสร้างวิดีโอสั้นแบบ HD ความยาว 5 และ 10 วินาที เราปรับโครงสร้างภาพให้คมชัดและลื่นไหลเป็นพิเศษสำหรับทั้งมือถือและเว็บ',
      faq5Question: 'แตกต่างจากโมเดลอื่นบนแพลตฟอร์ม (เช่น Kling, Luma) อย่างไร?',
      faq5Answer:
          'WeryAI Video 1.0 เป็นโมเดล native ของเรา จึงมีความเร็วตอบสนองและความเสถียรสูงสุดบน WeryAI เมื่อเทียบกับโมเดลจากภายนอก ถูกปรับให้เหมาะกับ “ความต่อเนื่องหลายช็อต” และ “ความเร็วในการสร้าง” เหมาะกับผู้สร้างที่ต้องการประสิทธิภาพสูง',

      // CTA section
      ctaTitle: 'พร้อมเริ่มสร้างสรรค์แล้วหรือยัง?',
      ctaDescription:
          'สัมผัส WeryAI Video 1.0 ตอนนี้ แล้วเปลี่ยนความคิดสร้างสรรค์ให้เป็นวิดีโอยอดเยี่ยม',
      ctaButton: 'เริ่มสร้างสรรค์',
      ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต · ทดลองใช้ฟรีสำหรับผู้ใช้ใหม่',
      },
    da: {
      // Model name
      modelName: 'WeryAI Video 1.0',

      // Page title and description
      pageTitle:
          'WeryAI Video 1.0 AI‑videogenerator - WeryAI’s flagskibs AI‑videoværktøj',
      pageDescription:
          'WeryAI Video 1.0 er WeryAI’s flagskibs‑AI‑videomodel med multi‑shot‑narrativ, intelligent billede‑til‑video, ultrahurtig rendering og bevægelsessimulering på fysikniveau. Prøv gratis på WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, AI‑videogenerator, AI‑videoproduktion, kunstig intelligens video, videoværktøj, gratis AI‑video, WeryAI, multi‑shot‑narrativ, billede til video',

      // Generator section
      generatorTitle: 'WeryAI Video 1.0 videogenerator',
      generatorDescription:
          'WeryAI Video 1.0 er WeryAI’s flagskibs‑AI‑videomodel. Den afspejler vores ultimative stræben efter den perfekte balance mellem “hastighed” og “kunstnerisk kvalitet” og har avanceret semantisk forståelse samt fysik‑simulationsmotorer. Den introducerer <span class="text-text-active">“native multi‑shot narrative”</span>. <span class="text-text-active">Prøv den gratis på WeryAI video generator</span>!',

      // Tabs
      tabImageToVideo: 'Billede til video',
      tabTextToVideo: 'Tekst til video',

      // Core features section
      coreFeaturesTitle: 'WeryAI Video 1.0 kernefunktioner',
      coreFeaturesSubtitle:
          'Udforsk kernefunktionerne i WeryAI Video 1.0 og start din næste generations videorejse',

      // Multi-shot narrative system
      multiShotTitle: 'Multi‑shot‑narrativt system',
      multiShotDescription:
          'Det centrale gennembrud i WeryAI Video 1.0. Det bryder begrænsningerne ved traditionel single‑shot‑generering og forstår/udfører komplekse kamerainstruktioner (som push, pull, pan, tilt og transitions). Modellen sikrer høj konsistens i karaktertræk og lys mellem shots og genererer videoer med fuld narrativ logik.',

      // Intelligent image-to-video engine
      imageToVideoTitle: 'Intelligent billede‑til‑video‑motor',
      imageToVideoDescription:
          'Giv statiske billeder liv. Upload blot et referencebillede, og WeryAI Video 1.0 identificerer motivets struktur og tilføjer fysik‑korrekte dynamiske effekter. Uanset om en stillestående person skal blinke og smile, eller vand skal flyde i et landskabsmaleri, får du naturlig animation uden at miste billedkvalitet.',

      // Ultra-fast rendering technology
      fastRenderTitle: 'Ultrahurtig render‑teknologi',
      fastRenderDescription:
          'Optimeret til højfrekvent skabelse. Takket være WeryAI’s unikke modeloptimering er Video 1.0’s genereringshastighed langt over branchestandard. Du kan få 5–10 sekunders HD‑klip på meget kort tid (typisk 40–60 sekunder), så kreativ iteration er uden ventetid.',

      // Physics-level motion simulation
      physicsTitle: 'Bevægelsessimulering på fysikniveau',
      physicsDescription:
          'Sig nej til forvrængning fra “AI‑hallucinationer”. Vores model er trænet på massive fysiske data og forstår væske, stof, tyngdekraft og andre fysiske regler. I genererede videoer er bevægelser glatte og naturlige, og kollisioner følger virkelighedens logik.',

      // How to use section
      howToUseTitle: 'Sådan bruger du WeryAI Video 1.0',
      howToUseSubtitle: 'Tre enkle trin til at komme i gang',
      step1Title: 'Vælg model',
      step1Description:
          'Vælg <span class="highlight-text">WeryAI Video 1.0</span> i AI‑videoværktøjet',
      step2Title: 'Indtast prompt',
      step2Description:
          'Beskriv din kreative historie i tekstfeltet, eller upload et billede for at aktivere “Billede til video”.',
      step3Title: 'Generér video',
      step3Description:
          'Vælg billedformat (16:9 filmisk eller 9:16 portræt) og varighed, klik “Generate”, og forhåndsvis/download dit mesterværk på få øjeblikke.',

      // Explore other models section
      exploreModelsTitle: 'Udforsk andre modeller',
      runwayTitle: 'Runway Gen-4.5 AI‑videogenerator',
      klingTitle: 'Kling 2.6 AI‑videogenerator',
      veo31Title: 'Google Veo 3.1 AI‑videogenerator',
      soraTitle: 'Sora 2 AI‑videogenerator',

      // FAQ section
      faqTitle: 'Ofte stillede spørgsmål',
      faq1Question: 'Hvad er WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 er WeryAI’s egen flagskibs‑AI‑videomodel. Den integrerer vores nyeste visuelle genereringsteknologi og er designet til maksimal hastighed og stærk narrativ kapacitet i videoproduktion.',
      faq2Question: 'Hvad kan WeryAI Video 1.0?',
      faq2Answer:
          'Den kan omdanne tekstmanuskripter eller stillbilleder til levende videoklip. Den er stærk i filmisk kamerabrug (kamera‑bevægelser og transitions) og komplekse fysiske dynamikker, perfekt til korte videoer, reklamer og animerede wallpapers.',
      faq3Question: 'Er den gratis at bruge på WeryAI?',
      faq3Answer:
          'Ja. Som platformfordel får alle registrerede brugere gratis kreditter dagligt for at prøve WeryAI Video 1.0. Opgradering til Pro giver hurtigere kanaler og højere daglige kvoter.',
      faq4Question: 'Hvad er kvaliteten og varigheden af de genererede videoer?',
      faq4Answer:
          'WeryAI Video 1.0 fokuserer på HD‑optimerede korte videoer på 5s og 10s. Vi har optimeret den visuelle struktur for krystalklar og glat afspilning på både mobil og web.',
      faq5Question: 'Hvordan adskiller den sig fra andre modeller (fx Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 er vores native model med den hurtigste responstid og højeste stabilitet på WeryAI. Sammenlignet med tredjepartsmodeller er den optimeret til “multi‑shot‑kontinuitet” og “genereringshastighed” og er derfor ideel for effektivitets‑fokuserede skabere.',

      // CTA section
      ctaTitle: 'Klar til at skabe?',
      ctaDescription:
          'Oplev WeryAI Video 1.0 nu, og forvandl din kreativitet til fantastiske videoer',
      ctaButton: 'Begynd at skabe',
      ctaDisclaimer: 'Intet kreditkort kræves · Gratis prøveperiode for nye brugere',
    },
    no: {
      // Model name
      modelName: 'WeryAI Video 1.0',

      // Page title and description
      pageTitle:
          'WeryAI Video 1.0 AI‑videogenerator - WeryAI sin flaggskip‑AI‑videoplattform',
      pageDescription:
          'WeryAI Video 1.0 er flaggskipmodellen for AI‑videogenerering fra WeryAI, med multi‑shot‑narrativ, intelligent bilde‑til‑video, ultrarask rendering og bevegelsessimulering på fysikknivå. Prøv gratis på WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, AI‑videogenerator, AI‑videoproduksjon, kunstig intelligens video, videoverktøy, gratis AI‑video, WeryAI, multi‑shot‑narrativ, bilde til video',

      // Generator section
      generatorTitle: 'WeryAI Video 1.0 videogenerator',
      generatorDescription:
          'WeryAI Video 1.0 er flaggskip‑AI‑videomodellen fra WeryAI. Den representerer vårt mål om perfekt balanse mellom “hastighet” og “kunst”, med avansert semantisk forståelse og fysikk‑simuleringsmotorer, og banebrytende <span class="text-text-active">“native multi‑shot narrative”</span>. <span class="text-text-active">Prøv gratis i WeryAI video generator</span>!',

      // Tabs
      tabImageToVideo: 'Bilde til video',
      tabTextToVideo: 'Tekst til video',

      // Core features section
      coreFeaturesTitle: 'WeryAI Video 1.0 kjernefunksjoner',
      coreFeaturesSubtitle:
          'Utforsk kjernefunksjonene i WeryAI Video 1.0 og start din neste generasjons videoreise',

      // Multi-shot narrative system
      multiShotTitle: 'Multi‑shot‑narrativt system',
      multiShotDescription:
          'Kjernen i WeryAI Video 1.0. Modellen bryter begrensningen til tradisjonell single‑shot‑generering ved å forstå og utføre komplekse kamerainstruksjoner (push, pull, pan, tilt og overganger). Den sikrer høy konsistens i karaktertrekk og scenelys mellom shots og genererer videoer med komplett narrativ logikk.',

      // Intelligent image-to-video engine
      imageToVideoTitle: 'Intelligent bilde‑til‑video‑motor',
      imageToVideoDescription:
          'Gjør statiske bilder levende. Bare last opp et referansebilde, så identifiserer WeryAI Video 1.0 motivets struktur og legger til fysikk‑riktige dynamiske effekter. Enten en stille person skal blunke og smile, eller vann skal flyte i et landskapsmaleri, blir animasjonen naturlig uten å miste kvalitet.',

      // Ultra-fast rendering technology
      fastRenderTitle: 'Ultrarask renderteknologi',
      fastRenderDescription:
          'Optimalisert for høyfrekvent produksjon. Med WeryAI sin unike modelloptimering er Video 1.0 langt raskere enn bransjestandard. Du kan få 5–10 sekunders HD‑klipp på svært kort tid (typisk 40–60 sekunder), så kreativ iterasjon er uten venting.',

      // Physics-level motion simulation
      physicsTitle: 'Bevegelsessimulering på fysikknivå',
      physicsDescription:
          'Si nei til forvrengning fra “AI‑hallusinasjoner”. Modellen er trent på massive fysiske dynamikkdata med dyp forståelse av væske, stoff, tyngdekraft og andre fysiske regler. I genererte videoer er bevegelser glatte og naturlige, og kollisjoner følger virkeligheten.',

      // How to use section
      howToUseTitle: 'Slik bruker du WeryAI Video 1.0',
      howToUseSubtitle: 'Tre enkle trinn for å komme i gang',
      step1Title: 'Velg modell',
      step1Description:
          'Velg <span class="highlight-text">WeryAI Video 1.0</span> i AI‑videoverktøyet',
      step2Title: 'Skriv prompt',
      step2Description:
          'Beskriv historien i tekstfeltet, eller last opp et bilde for å aktivere “Bilde til video”.',
      step3Title: 'Generer video',
      step3Description:
          'Velg format (16:9 filmatisk eller 9:16 portrett) og varighet, klikk “Generate”, og forhåndsvis og last ned mesterverket på øyeblikk.',

      // Explore other models section
      exploreModelsTitle: 'Utforsk andre modeller',
      runwayTitle: 'Runway Gen-4.5 AI‑videogenerator',
      klingTitle: 'Kling 2.6 AI‑videogenerator',
      veo31Title: 'Google Veo 3.1 AI‑videogenerator',
      soraTitle: 'Sora 2 AI‑videogenerator',

      // FAQ section
      faqTitle: 'Ofte stilte spørsmål',
      faq1Question: 'Hva er WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 er flaggskip‑AI‑videomodellen utviklet av WeryAI. Den integrerer vår nyeste visuelle genereringsteknologi og er designet for maksimal hastighet og sterk narrativ kapasitet.',
      faq2Question: 'Hva kan WeryAI Video 1.0 gjøre?',
      faq2Answer:
          'Den kan gjøre tekstmanus eller stillbilder om til levende videoklipp. Den er sterk på filmatisk kamerabruk (kamerabevegelser og overganger) og komplekse fysiske dynamikker, perfekt for korte videoer, reklamer og animerte bakgrunner.',
      faq3Question: 'Er den gratis å bruke på WeryAI?',
      faq3Answer:
          'Ja. Som plattformfordel får alle registrerte brukere gratis kreditter daglig for å teste WeryAI Video 1.0. Oppgradering til Pro gir raskere kanaler og høyere daglige kvoter.',
      faq4Question: 'Hva er kvaliteten og varigheten på videoene?',
      faq4Answer:
          'WeryAI Video 1.0 fokuserer på HD‑optimaliserte korte videoer på 5s og 10s. Vi har optimalisert den visuelle strukturen for krystallklar og jevn avspilling på mobil og web.',
      faq5Question: 'Hvordan skiller den seg fra andre modeller (Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 er vår native modell med raskest responstid og høyest stabilitet på WeryAI. Sammenlignet med tredjepartsmodeller er den optimalisert for “multi‑shot‑kontinuitet” og “genereringshastighet”, og passer best for effektivitetsfokuserte skapere.',

      // CTA section
      ctaTitle: 'Klar til å skape?',
      ctaDescription:
          'Opplev WeryAI Video 1.0 nå og gjør kreativiteten din om til fantastiske videoer',
      ctaButton: 'Begynn å skape',
      ctaDisclaimer: 'Ingen kredittkort nødvendig · Gratis prøveperiode for nye brukere',
    },
    nl: {
      // Model name
      modelName: 'WeryAI Video 1.0',

      // Page title and description
      pageTitle:
          'WeryAI Video 1.0 AI‑videogenerator - WeryAI’s vlaggenschip AI‑videotool',
      pageDescription:
          'WeryAI Video 1.0 is het vlaggenschip‑AI‑videomodel van WeryAI, met multi‑shot‑verhalen, slimme beeld‑naar‑video, ultrasnelle rendering en bewegingssimulatie op fysicaniveau. Probeer gratis op WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, AI‑videogenerator, AI‑videocreatie, kunstmatige‑intelligentie video, videogenerator, gratis AI‑video, WeryAI, multi‑shot verhaal, beeld naar video',

      // Generator section
      generatorTitle: 'WeryAI Video 1.0 videogenerator',
      generatorDescription:
          'WeryAI Video 1.0 is het vlaggenschip‑AI‑videomodel van WeryAI. Het is onze ultieme zoektocht naar de perfecte balans tussen “snelheid” en “kunst”, met geavanceerd semantisch begrip en fysica‑simulatie‑engines, en baanbrekende <span class="text-text-active">“native multi‑shot narrative”</span>. <span class="text-text-active">Probeer het gratis op WeryAI video generator</span>!',

      // Tabs
      tabImageToVideo: 'Beeld naar video',
      tabTextToVideo: 'Tekst naar video',

      // Core features section
      coreFeaturesTitle: 'WeryAI Video 1.0 kernfuncties',
      coreFeaturesSubtitle:
          'Ontdek de kernfuncties van WeryAI Video 1.0 en start je next‑gen videoreis',

      // Multi-shot narrative system
      multiShotTitle: 'Multi‑shot verhaalsysteem',
      multiShotDescription:
          'De kerninnovatie van WeryAI Video 1.0. Het doorbreekt de beperkingen van traditionele single‑shot‑generatie en begrijpt/voert complexe camerainstructies uit (zoals push, pull, pan, tilt en overgangen). Het model behoudt consistente karaktertrekken en licht tussen shots en genereert video’s met complete narratieve logica.',

      // Intelligent image-to-video engine
      imageToVideoTitle: 'Slimme beeld‑naar‑video‑engine',
      imageToVideoDescription:
          'Geef statische beelden leven. Upload een referentiebeeld en WeryAI Video 1.0 herkent de structuur van het onderwerp en voegt fysica‑conforme dynamische effecten toe. Of het nu gaat om knipperen en glimlachen of stromend water in een landschapschilderij, de animatie is natuurlijk en behoudt de oorspronkelijke kwaliteit.',

      // Ultra-fast rendering technology
      fastRenderTitle: 'Ultrasnelle rendertechnologie',
      fastRenderDescription:
          'Geoptimaliseerd voor hoge creatiefrequentie. Dankzij WeryAI’s unieke modeloptimalisatie ligt de snelheid van Video 1.0 ver boven het branchegemiddelde. Je krijgt 5–10 seconden HD‑video in zeer korte tijd (meestal 40–60 s), waardoor itereren zonder wachttijd kan.',

      // Physics-level motion simulation
      physicsTitle: 'Bewegingssimulatie op fysicaniveau',
      physicsDescription:
          'Zeg nee tegen vervorming door “AI‑hallucinaties”. Ons model is getraind op enorme fysische dynamiekdata met diep begrip van vloeistof, stof, zwaartekracht en andere regels. Bewegingen zijn vloeiend en botsingen volgen de werkelijkheid.',

      // How to use section
      howToUseTitle: 'Zo gebruik je WeryAI Video 1.0',
      howToUseSubtitle: 'Drie eenvoudige stappen om te starten',
      step1Title: 'Model selecteren',
      step1Description:
          'Selecteer <span class="highlight-text">WeryAI Video 1.0</span> in de AI‑videotool',
      step2Title: 'Prompt invoeren',
      step2Description:
          'Beschrijf je creatieve verhaal in het tekstvak of upload een beeld om “Beeld naar video” te activeren.',
      step3Title: 'Video genereren',
      step3Description:
          'Kies je beeldverhouding (16:9 filmisch of 9:16 portret) en videoduur, klik op “Generate” en bekijk/download je meesterwerk in een oogwenk.',

      // Explore other models section
      exploreModelsTitle: 'Ontdek andere modellen',
      runwayTitle: 'Runway Gen-4.5 AI‑videogenerator',
      klingTitle: 'Kling 2.6 AI‑videogenerator',
      veo31Title: 'Google Veo 3.1 AI‑videogenerator',
      soraTitle: 'Sora 2 AI‑videogenerator',

      // FAQ section
      faqTitle: 'Veelgestelde vragen',
      faq1Question: 'Wat is WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 is het vlaggenschip‑AI‑videomodel dat WeryAI zelfstandig heeft gelanceerd. Het integreert onze nieuwste visuele generatietechnologie en is ontworpen voor maximale snelheid en sterke narratieve mogelijkheden.',
      faq2Question: 'Wat kan WeryAI Video 1.0?',
      faq2Answer:
          'Het kan tekstscripts of statische beelden omzetten in levendige videoclips. Het is sterk in filmische camerataal (bewegingen en overgangen) en complexe fysische dynamiek — ideaal voor korte video’s, advertenties en geanimeerde wallpapers.',
      faq3Question: 'Is het gratis te gebruiken op WeryAI?',
      faq3Answer:
          'Ja. Als platformvoordeel ontvangen alle geregistreerde gebruikers dagelijks gratis credits om WeryAI Video 1.0 te ervaren. Upgraden naar Pro geeft snellere kanalen en meer dagelijkse quota.',
      faq4Question: 'Wat is de kwaliteit en duur van de video’s?',
      faq4Answer:
          'WeryAI Video 1.0 focust op HD‑geoptimaliseerde korte video’s van 5s en 10s. We hebben de visuele structuur speciaal geoptimaliseerd voor kristalheldere, soepele weergave op mobiel en web.',
      faq5Question: 'Hoe verschilt het van andere modellen (Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 is ons native model met de snelste responstijd en hoogste stabiliteit op WeryAI. Vergeleken met third‑party modellen is het geoptimaliseerd voor “multi‑shot‑continuïteit” en “generatiesnelheid”, ideaal voor efficiency‑gerichte makers.',

      // CTA section
      ctaTitle: 'Klaar om te creëren?',
      ctaDescription:
          'Ervaar WeryAI Video 1.0 nu en zet je creativiteit om in geweldige video’s',
      ctaButton: 'Begin met creëren',
      ctaDisclaimer: 'Geen creditcard nodig · Gratis proefperiode voor nieuwe gebruikers',
    },
    id: {
      // Model name
      modelName: 'WeryAI Video 1.0',

      // Page title and description
      pageTitle:
          'WeryAI Video 1.0 Generator Video AI - Alat Pembuatan Video AI Unggulan WeryAI',
      pageDescription:
          'WeryAI Video 1.0 adalah model AI video unggulan WeryAI, menghadirkan narasi multi‑shot, image‑to‑video cerdas, rendering ultra‑cepat, dan simulasi gerak tingkat fisika. Coba gratis di WeryAI.',
      pageKeywords:
          'WeryAI Video 1.0, generator video AI, pembuatan video AI, video kecerdasan buatan, alat generasi video, video AI gratis, WeryAI, narasi multi-shot, image to video',

      // Generator section
      generatorTitle: 'Generator Video WeryAI Video 1.0',
      generatorDescription:
          'WeryAI Video 1.0 adalah model AI video unggulan WeryAI. Ini mewakili pencarian kami atas keseimbangan sempurna antara “kecepatan” dan “seni”, dengan pemahaman semantik tingkat lanjut dan mesin simulasi fisika, serta kemampuan <span class="text-text-active">“native multi-shot narrative”</span>. <span class="text-text-active">Coba gratis di WeryAI video generator</span>!',

      // Tabs
      tabImageToVideo: 'Gambar ke video',
      tabTextToVideo: 'Teks ke video',

      // Core features section
      coreFeaturesTitle: 'Fitur inti WeryAI Video 1.0',
      coreFeaturesSubtitle:
          'Jelajahi fitur inti WeryAI Video 1.0 dan mulai perjalanan kreasi video generasi berikutnya',

      // Multi-shot narrative system
      multiShotTitle: 'Sistem narasi multi‑shot',
      multiShotDescription:
          'Terobosan utama WeryAI Video 1.0. Mengatasi keterbatasan generasi single‑shot tradisional, memahami dan mengeksekusi instruksi kamera kompleks (seperti push, pull, pan, tilt, dan transisi). Model menjaga konsistensi fitur karakter dan pencahayaan antar‑shot, menghasilkan video dengan logika naratif utuh.',

      // Intelligent image-to-video engine
      imageToVideoTitle: 'Mesin image‑to‑video cerdas',
      imageToVideoDescription:
          'Hidupkan gambar statis. Cukup unggah gambar referensi, WeryAI Video 1.0 mengidentifikasi struktur subjek dan menambahkan efek dinamis sesuai fisika. Baik membuat seseorang berkedip dan tersenyum secara alami maupun membuat air mengalir pada lukisan lanskap, animasi tetap natural sambil mempertahankan kualitas gambar.',

      // Ultra-fast rendering technology
      fastRenderTitle: 'Teknologi rendering ultra‑cepat',
      fastRenderDescription:
          'Dioptimalkan untuk kreasi berfrekuensi tinggi. Berkat optimasi arsitektur model khas WeryAI, kecepatan generasi Video 1.0 melampaui rata‑rata industri. Anda dapat memperoleh klip HD 5–10 detik dalam waktu sangat singkat (biasanya 40–60 detik), sehingga iterasi kreatif tanpa menunggu.',

      // Physics-level motion simulation
      physicsTitle: 'Simulasi gerak tingkat fisika',
      physicsDescription:
          'Tolak distorsi akibat “AI hallucination”. Model kami dilatih pada data dinamika fisika masif dengan pemahaman mendalam tentang fluida, kain, gravitasi, dan aturan fisika lainnya. Dalam video yang dihasilkan, gerakan karakter halus dan alami, dan tabrakan objek mengikuti logika dunia nyata.',

      // How to use section
      howToUseTitle: 'Cara menggunakan WeryAI Video 1.0',
      howToUseSubtitle: 'Tiga langkah sederhana untuk memulai',
      step1Title: 'Pilih model',
      step1Description:
          'Pilih model <span class="highlight-text">WeryAI Video 1.0</span> di alat video AI',
      step2Title: 'Masukkan prompt',
      step2Description:
          'Jelaskan cerita kreatif Anda di kotak teks, atau unggah gambar untuk mengaktifkan mode “Image to Video”.',
      step3Title: 'Buat video',
      step3Description:
          'Pilih rasio aspek (16:9 sinematik atau 9:16 potret) dan durasi video, klik “Generate”, lalu pratinjau dan unduh karya Anda dalam sekejap.',

      // Explore other models section
      exploreModelsTitle: 'Jelajahi model lain',
      runwayTitle: 'Runway Gen-4.5 AI Video Generator',
      klingTitle: 'Kling 2.6 AI Video Generator',
      veo31Title: 'Google Veo 3.1 AI Video Generator',
      soraTitle: 'Sora 2 AI Video Generator',

      // FAQ section
      faqTitle: 'Pertanyaan yang sering diajukan',
      faq1Question: 'Apa itu WeryAI Video 1.0?',
      faq1Answer:
          'WeryAI Video 1.0 adalah model AI video unggulan yang diluncurkan sendiri oleh WeryAI. Mengintegrasikan teknologi generasi visual terbaru kami, dirancang untuk memberikan kecepatan tercepat dan kemampuan naratif terkuat untuk pembuatan video.',
      faq2Question: 'Apa yang bisa dilakukan WeryAI Video 1.0?',
      faq2Answer:
          'Dapat mengubah naskah teks atau gambar statis menjadi klip video yang hidup. Unggul dalam bahasa kamera sinematik (gerakan kamera dan transisi) serta dinamika fisik kompleks, cocok untuk video pendek, iklan, dan wallpaper animasi.',
      faq3Question: 'Apakah gratis digunakan di WeryAI?',
      faq3Answer:
          'Ya. Sebagai benefit platform, semua pengguna terdaftar menerima kredit gratis harian untuk mencoba WeryAI Video 1.0. Upgrade ke Pro memberi kanal generasi lebih cepat dan kuota harian lebih besar.',
      faq4Question: 'Bagaimana kualitas dan durasi video yang dihasilkan?',
      faq4Answer:
          'WeryAI Video 1.0 berfokus pada video pendek HD teroptimasi berdurasi 5 dan 10 detik. Kami mengoptimalkan struktur visual untuk pemutaran yang jernih dan halus di perangkat mobile dan web.',
      faq5Question: 'Apa bedanya dengan model lain di platform (Kling, Luma)?',
      faq5Answer:
          'WeryAI Video 1.0 adalah model native kami dengan kecepatan respons tercepat dan stabilitas tertinggi di WeryAI. Dibanding model pihak ketiga, ia dioptimalkan untuk “kontinuitas multi‑shot” dan “kecepatan generasi”, sehingga lebih cocok bagi kreator yang fokus pada efisiensi.',

      // CTA section
      ctaTitle: 'Siap mulai berkarya?',
      ctaDescription:
          'Rasakan WeryAI Video 1.0 sekarang dan ubah kreativitas Anda menjadi video yang luar biasa',
      ctaButton: 'Mulai Berkarya',
      ctaDisclaimer: 'Tidak perlu kartu kredit · Uji coba gratis untuk pengguna baru',
    },
    tr: {
      // Model name
      modelName: 'WeryAI Video 1.0',

      // Page title and description
      pageTitle:
          'WeryAI Video 1.0 AI Video Oluşturucu - WeryAI amiral gemisi AI video aracı',
      pageDescription:
          'WeryAI Video 1.0, çoklu‑shot anlatı, akıllı image‑to‑video, ultra hızlı render ve fizik seviyesinde hareket simülasyonu sunan WeryAI amiral gemisi AI video modelidir. WeryAI’de ücretsiz deneyin.',
      pageKeywords:
          'WeryAI Video 1.0, AI video oluşturucu, AI video üretimi, yapay zeka video, video üretim aracı, ücretsiz AI video, WeryAI, çoklu-shot anlatı, image to video',

      // Generator section
      generatorTitle: 'WeryAI Video 1.0 Video Oluşturucu',
      generatorDescription:
          'WeryAI Video 1.0, WeryAI tarafından geliştirilen amiral gemisi AI video modelidir. “Hız” ve “sanat” arasındaki ideal dengeyi hedefler; gelişmiş anlamsal anlayış ve fizik simülasyon motorlarıyla <span class="text-text-active">“native multi‑shot narrative”</span> yeteneğini öncüler. <span class="text-text-active">WeryAI video generator’da ücretsiz deneyin</span>!',

      // Tabs
      tabImageToVideo: 'Görselden videoya',
      tabTextToVideo: 'Metinden videoya',

      // Core features section
      coreFeaturesTitle: 'WeryAI Video 1.0 Temel Özellikler',
      coreFeaturesSubtitle:
          'WeryAI Video 1.0’ın temel özelliklerini keşfedin ve yeni nesil video üretim yolculuğunuza başlayın',

      // Multi-shot narrative system
      multiShotTitle: 'Multi‑shot anlatı sistemi',
      multiShotDescription:
          'WeryAI Video 1.0’ın temel atılımı. Geleneksel tek‑shot üretimin sınırlarını aşar, karmaşık kamera komutlarını (push, pull, pan, tilt ve geçişler) anlar ve uygular. Model, shot geçişlerinde karakter özellikleri ve sahne ışığını tutarlı tutarak tam anlatı mantığına sahip videolar üretir.',

      // Intelligent image-to-video engine
      imageToVideoTitle: 'Akıllı image‑to‑video motoru',
      imageToVideoDescription:
          'Statik görüntülere hayat verin. Bir referans görsel yükleyin; WeryAI Video 1.0 özne yapısını doğru biçimde tanımlar ve fizik uyumlu dinamik efektler ekler. İster bir kişinin doğal şekilde göz kırpıp gülümsemesi, ister bir manzara resminde suyun akması olsun, animasyon doğal görünür ve görüntü kalitesi korunur.',

      // Ultra-fast rendering technology
      fastRenderTitle: 'Ultra hızlı render teknolojisi',
      fastRenderDescription:
          'Yüksek frekanslı üretim için optimize edilmiştir. WeryAI’nin özgün model mimarisi optimizasyonu sayesinde Video 1.0’ın üretim hızı sektör ortalamasını aşar. 5–10 saniyelik HD klipleri çok kısa sürede (genellikle 40–60 saniye) elde edebilir, yaratıcı iterasyonu beklemeden sürdürebilirsiniz.',

      // Physics-level motion simulation
      physicsTitle: 'Fizik seviyesinde hareket simülasyonu',
      physicsDescription:
          '“AI halüsinasyonlarının” yol açtığı bozulmaları reddedin. Modelimiz, akışkanlar, kumaş, yerçekimi ve diğer fizik kurallarına dair derin anlayışa sahip büyük fizik dinamik verileriyle eğitilmiştir. Üretilen videolarda hareketler akıcıdır ve çarpışmalar gerçek dünya mantığına uyar.',

      // How to use section
      howToUseTitle: 'WeryAI Video 1.0 nasıl kullanılır?',
      howToUseSubtitle: 'Üç basit adımda başlayın',
      step1Title: 'Model seçin',
      step1Description:
          'AI video aracında <span class="highlight-text">WeryAI Video 1.0</span> modelini seçin',
      step2Title: 'Prompt girin',
      step2Description:
          'Yaratıcı hikâyenizi metin kutusuna yazın veya “Image to Video” modunu açmak için bir görsel yükleyin.',
      step3Title: 'Video üretin',
      step3Description:
          'Hedef en‑boy oranını (16:9 sinematik veya 9:16 portre) ve süreyi seçin, “Generate”a tıklayın ve videonuzu kısa sürede önizleyip indirin.',

      // Explore other models section
      exploreModelsTitle: 'Diğer modelleri keşfedin',
      runwayTitle: 'Runway Gen-4.5 AI Video Oluşturucu',
      klingTitle: 'Kling 2.6 AI Video Oluşturucu',
      veo31Title: 'Google Veo 3.1 AI Video Oluşturucu',
      soraTitle: 'Sora 2 AI Video Oluşturucu',

      // FAQ section
      faqTitle: 'Sıkça sorulan sorular',
      faq1Question: 'WeryAI Video 1.0 nedir?',
      faq1Answer:
          'WeryAI Video 1.0, WeryAI tarafından bağımsız olarak geliştirilen amiral gemisi AI video modelidir. En yeni görsel üretim teknolojimizi entegre eder ve kullanıcılara en yüksek hız ile en güçlü anlatı kabiliyetini sunmak için tasarlanmıştır.',
      faq2Question: 'WeryAI Video 1.0 neler yapabilir?',
      faq2Answer:
          'Metin senaryolarını veya statik görselleri canlı video kliplere dönüştürebilir. Filmik kamera dili (kamera hareketleri ve geçişler) ve karmaşık fizik dinamiklerinde güçlüdür; kısa videolar, reklamlar ve animasyonlu duvar kâğıtları için idealdir.',
      faq3Question: 'WeryAI’de ücretsiz mi?',
      faq3Answer:
          'Evet. Platform avantajı olarak tüm kayıtlı kullanıcılar her gün WeryAI Video 1.0’ı deneyimlemek için ücretsiz kredi alır. Pro’ya yükseltme daha hızlı kanallar ve daha yüksek günlük kota sağlar.',
      faq4Question: 'Üretilen videoların kalitesi ve süresi nedir?',
      faq4Answer:
          'WeryAI Video 1.0, 5s ve 10s’lik HD optimize kısa videolara odaklanır. Mobil ve webde kristal netlikte, akıcı oynatma için görsel yapıyı özel olarak optimize ettik.',
      faq5Question: 'Diğer modellerden (Kling, Luma) farkı nedir?',
      faq5Answer:
          'WeryAI Video 1.0 native modelimizdir; WeryAI’de en hızlı tepki süresi ve en yüksek stabiliteyi sunar. Üçüncü taraf modellere kıyasla “multi‑shot süreklilik” ve “üretim hızı” için optimize edilmiştir; verimlilik odaklı yaratıcılar için daha uygundur.',

      // CTA section
      ctaTitle: 'Üretime hazır mısınız?',
      ctaDescription:
          'WeryAI Video 1.0’ı şimdi deneyin ve yaratıcılığınızı etkileyici videolara dönüştürün',
      ctaButton: 'Oluşturmaya Başla',
      ctaDisclaimer: 'Kredi kartı gerekmez · Yeni kullanıcılar için ücretsiz deneme',
    },
}
